<div class="dotmap minimal">
  <div class="row r1">
    <span class="dot r1d1 water"></span>
    <span class="dot r1d2 water"></span>
    <span class="dot r1d3 water"></span>
    <span class="dot r1d4 water"></span>
    <span class="dot r1d5 water"></span>
    <span class="dot r1d6 water"></span>
    <span class="dot r1d7 water"></span>
    <span class="dot r1d8 water"></span>
    <span class="dot r1d9 water"></span>
    <span class="dot r1d10 water"></span>
    <span class="dot r1d11 water"></span>
    <span class="dot r1d12 water"></span>
    <span class="dot r1d13 water"></span>
    <span class="dot r1d14 water"></span>
    <span class="dot r1d15 water"></span>
    <span class="dot r1d16 water"></span>
    <span class="dot r1d17 water"></span>
    <span class="dot r1d18 water"></span>
    <span class="dot r1d19 water"></span>
    <span class="dot r1d20 water"></span>
    <span class="dot r1d21 water"></span>
    <span class="dot r1d22 water"></span>
    <span class="dot r1d23 water"></span>
    <span class="dot r1d24 water"></span>
    <span class="dot r1d25 north-america"></span>
    <span class="dot r1d26 north-america"></span>
    <span class="dot r1d27 north-america"></span>
    <span class="dot r1d28 north-america"></span>
    <span class="dot r1d29 water"></span>
    <span class="dot r1d30 water"></span>
    <span class="dot r1d31 water"></span>
    <span class="dot r1d32 water"></span>
    <span class="dot r1d33 water"></span>
    <span class="dot r1d34 water"></span>
    <span class="dot r1d35 water"></span>
    <span class="dot r1d36 water"></span>
    <span class="dot r1d37 water"></span>
    <span class="dot r1d38 water"></span>
    <span class="dot r1d39 water"></span>
    <span class="dot r1d40 water"></span>
    <span class="dot r1d41 water"></span>
    <span class="dot r1d42 water"></span>
    <span class="dot r1d43 water"></span>
    <span class="dot r1d44 water"></span>
    <span class="dot r1d45 water"></span>
    <span class="dot r1d46 water"></span>
    <span class="dot r1d47 water"></span>
    <span class="dot r1d48 water"></span>
    <span class="dot r1d49 water"></span>
    <span class="dot r1d50 water"></span>
    <span class="dot r1d51 water"></span>
    <span class="dot r1d52 water"></span>
    <span class="dot r1d53 water"></span>
    <span class="dot r1d54 water"></span>
    <span class="dot r1d55 water"></span>
    <span class="dot r1d56 water"></span>
    <span class="dot r1d57 water"></span>
    <span class="dot r1d58 water"></span>
    <span class="dot r1d59 water"></span>
    <span class="dot r1d60 water"></span>
    <span class="dot r1d61 water"></span>
    <span class="dot r1d62 water"></span>
    <span class="dot r1d63 water"></span>
    <span class="dot r1d64 water"></span>
    <span class="dot r1d65 water"></span>
    <span class="dot r1d66 water"></span>
    <span class="dot r1d67 water"></span>
    <span class="dot r1d68 water"></span>
  </div>
  <div class="row r2">
    <span class="dot r2d1 water"></span>
    <span class="dot r2d2 water"></span>
    <span class="dot r2d3 water"></span>
    <span class="dot r2d4 water"></span>
    <span class="dot r2d5 water"></span>
    <span class="dot r2d6 water"></span>
    <span class="dot r2d7 water"></span>
    <span class="dot r2d8 water"></span>
    <span class="dot r2d9 water"></span>
    <span class="dot r2d10 water"></span>
    <span class="dot r2d11 water"></span>
    <span class="dot r2d12 water"></span>
    <span class="dot r2d13 water"></span>
    <span class="dot r2d14 water"></span>
    <span class="dot r2d15 water"></span>
    <span class="dot r2d16 water"></span>
    <span class="dot r2d17 north-america"></span>
    <span class="dot r2d18 north-america"></span>
    <span class="dot r2d19 north-america"></span>
    <span class="dot r2d20 north-america"></span>
    <span class="dot r2d21 water"></span>
    <span class="dot r2d22 north-america"></span>
    <span class="dot r2d23 north-america"></span>
    <span class="dot r2d24 north-america"></span>
    <span class="dot r2d25 north-america"></span>
    <span class="dot r2d26 north-america"></span>
    <span class="dot r2d27 north-america"></span>
    <span class="dot r2d28 north-america"></span>
    <span class="dot r2d29 north-america"></span>
    <span class="dot r2d30 north-america"></span>
    <span class="dot r2d31 water"></span>
    <span class="dot r2d32 water"></span>
    <span class="dot r2d33 water"></span>
    <span class="dot r2d34 water"></span>
    <span class="dot r2d35 water"></span>
    <span class="dot r2d36 water"></span>
    <span class="dot r2d37 water"></span>
    <span class="dot r2d38 water"></span>
    <span class="dot r2d39 water"></span>
    <span class="dot r2d40 water"></span>
    <span class="dot r2d41 water"></span>
    <span class="dot r2d42 water"></span>
    <span class="dot r2d43 water"></span>
    <span class="dot r2d44 water"></span>
    <span class="dot r2d45 water"></span>
    <span class="dot r2d46 water"></span>
    <span class="dot r2d47 water"></span>
    <span class="dot r2d48 water"></span>
    <span class="dot r2d49 water"></span>
    <span class="dot r2d50 water"></span>
    <span class="dot r2d51 water"></span>
    <span class="dot r2d52 water"></span>
    <span class="dot r2d53 water"></span>
    <span class="dot r2d54 water"></span>
    <span class="dot r2d55 water"></span>
    <span class="dot r2d56 water"></span>
    <span class="dot r2d57 water"></span>
    <span class="dot r2d58 water"></span>
    <span class="dot r2d59 water"></span>
    <span class="dot r2d60 water"></span>
    <span class="dot r2d61 water"></span>
    <span class="dot r2d62 water"></span>
    <span class="dot r2d63 water"></span>
    <span class="dot r2d64 water"></span>
    <span class="dot r2d65 water"></span>
    <span class="dot r2d66 water"></span>
    <span class="dot r2d67 water"></span>
    <span class="dot r2d68 water"></span>
  </div>
  <div class="row r3">
    <span class="dot r3d1 water"></span>
    <span class="dot r3d2 water"></span>
    <span class="dot r3d3 water"></span>
    <span class="dot r3d4 water"></span>
    <span class="dot r3d5 water"></span>
    <span class="dot r3d6 water"></span>
    <span class="dot r3d7 water"></span>
    <span class="dot r3d8 water"></span>
    <span class="dot r3d9 water"></span>
    <span class="dot r3d10 water"></span>
    <span class="dot r3d11 water"></span>
    <span class="dot r3d12 water"></span>
    <span class="dot r3d13 water"></span>
    <span class="dot r3d14 water"></span>
    <span class="dot r3d15 north-america"></span>
    <span class="dot r3d16 north-america"></span>
    <span class="dot r3d17 north-america"></span>
    <span class="dot r3d18 north-america"></span>
    <span class="dot r3d19 north-america"></span>
    <span class="dot r3d20 water"></span>
    <span class="dot r3d21 north-america"></span>
    <span class="dot r3d22 north-america"></span>
    <span class="dot r3d23 north-america"></span>
    <span class="dot r3d24 north-america"></span>
    <span class="dot r3d25 north-america"></span>
    <span class="dot r3d26 north-america"></span>
    <span class="dot r3d27 north-america"></span>
    <span class="dot r3d28 north-america"></span>
    <span class="dot r3d29 north-america"></span>
    <span class="dot r3d30 water"></span>
    <span class="dot r3d31 water"></span>
    <span class="dot r3d32 water"></span>
    <span class="dot r3d33 water"></span>
    <span class="dot r3d34 water"></span>
    <span class="dot r3d35 europe"></span>
    <span class="dot r3d36 europe"></span>
    <span class="dot r3d37 europe"></span>
    <span class="dot r3d38 europe"></span>
    <span class="dot r3d39 water"></span>
    <span class="dot r3d40 water"></span>
    <span class="dot r3d41 water"></span>
    <span class="dot r3d42 asia"></span>
    <span class="dot r3d43 asia"></span>
    <span class="dot r3d44 asia"></span>
    <span class="dot r3d45 water"></span>
    <span class="dot r3d46 water"></span>
    <span class="dot r3d47 water"></span>
    <span class="dot r3d48 water"></span>
    <span class="dot r3d49 water"></span>
    <span class="dot r3d50 asia"></span>
    <span class="dot r3d51 asia"></span>
    <span class="dot r3d52 water"></span>
    <span class="dot r3d53 water"></span>
    <span class="dot r3d54 water"></span>
    <span class="dot r3d55 water"></span>
    <span class="dot r3d56 water"></span>
    <span class="dot r3d57 water"></span>
    <span class="dot r3d58 water"></span>
    <span class="dot r3d59 water"></span>
    <span class="dot r3d60 water"></span>
    <span class="dot r3d61 water"></span>
    <span class="dot r3d62 water"></span>
    <span class="dot r3d63 water"></span>
    <span class="dot r3d64 water"></span>
    <span class="dot r3d65 water"></span>
    <span class="dot r3d66 water"></span>
    <span class="dot r3d67 water"></span>
    <span class="dot r3d68 water"></span>
  </div>
  <div class="row r4">
    <span class="dot r4d1 water"></span>
    <span class="dot r4d2 water"></span>
    <span class="dot r4d3 water"></span>
    <span class="dot r4d4 water"></span>
    <span class="dot r4d5 water"></span>
    <span class="dot r4d6 water"></span>
    <span class="dot r4d7 water"></span>
    <span class="dot r4d8 water"></span>
    <span class="dot r4d9 water"></span>
    <span class="dot r4d10 water"></span>
    <span class="dot r4d11 north-america"></span>
    <span class="dot r4d12 north-america"></span>
    <span class="dot r4d13 north-america"></span>
    <span class="dot r4d14 water"></span>
    <span class="dot r4d15 water"></span>
    <span class="dot r4d16 north-america"></span>
    <span class="dot r4d17 north-america"></span>
    <span class="dot r4d18 water"></span>
    <span class="dot r4d19 water"></span>
    <span class="dot r4d20 north-america"></span>
    <span class="dot r4d21 north-america"></span>
    <span class="dot r4d22 north-america"></span>
    <span class="dot r4d23 north-america"></span>
    <span class="dot r4d24 north-america"></span>
    <span class="dot r4d25 north-america"></span>
    <span class="dot r4d26 north-america"></span>
    <span class="dot r4d27 north-america"></span>
    <span class="dot r4d28 north-america"></span>
    <span class="dot r4d29 north-america"></span>
    <span class="dot r4d30 water"></span>
    <span class="dot r4d31 water"></span>
    <span class="dot r4d32 water"></span>
    <span class="dot r4d33 water"></span>
    <span class="dot r4d34 water"></span>
    <span class="dot r4d35 europe"></span>
    <span class="dot r4d36 europe"></span>
    <span class="dot r4d37 europe"></span>
    <span class="dot r4d38 europe"></span>
    <span class="dot r4d39 water"></span>
    <span class="dot r4d40 water"></span>
    <span class="dot r4d41 water"></span>
    <span class="dot r4d42 water"></span>
    <span class="dot r4d43 water"></span>
    <span class="dot r4d44 water"></span>
    <span class="dot r4d45 water"></span>
    <span class="dot r4d46 water"></span>
    <span class="dot r4d47 water"></span>
    <span class="dot r4d48 water"></span>
    <span class="dot r4d49 water"></span>
    <span class="dot r4d50 water"></span>
    <span class="dot r4d51 asia"></span>
    <span class="dot r4d52 asia"></span>
    <span class="dot r4d53 water"></span>
    <span class="dot r4d54 water"></span>
    <span class="dot r4d55 water"></span>
    <span class="dot r4d56 water"></span>
    <span class="dot r4d57 water"></span>
    <span class="dot r4d58 water"></span>
    <span class="dot r4d59 water"></span>
    <span class="dot r4d60 water"></span>
    <span class="dot r4d61 water"></span>
    <span class="dot r4d62 water"></span>
    <span class="dot r4d63 water"></span>
    <span class="dot r4d64 water"></span>
    <span class="dot r4d65 water"></span>
    <span class="dot r4d66 water"></span>
    <span class="dot r4d67 water"></span>
    <span class="dot r4d68 water"></span>
  </div>
  <div class="row r5">
    <span class="dot r5d1 water"></span>
    <span class="dot r5d2 water"></span>
    <span class="dot r5d3 water"></span>
    <span class="dot r5d4 water"></span>
    <span class="dot r5d5 water"></span>
    <span class="dot r5d6 water"></span>
    <span class="dot r5d7 water"></span>
    <span class="dot r5d8 water"></span>
    <span class="dot r5d9 water"></span>
    <span class="dot r5d10 north-america"></span>
    <span class="dot r5d11 north-america"></span>
    <span class="dot r5d12 water"></span>
    <span class="dot r5d13 water"></span>
    <span class="dot r5d14 north-america"></span>
    <span class="dot r5d15 north-america"></span>
    <span class="dot r5d16 north-america"></span>
    <span class="dot r5d17 north-america"></span>
    <span class="dot r5d18 water"></span>
    <span class="dot r5d19 water"></span>
    <span class="dot r5d20 north-america"></span>
    <span class="dot r5d21 north-america"></span>
    <span class="dot r5d22 north-america"></span>
    <span class="dot r5d23 north-america"></span>
    <span class="dot r5d24 north-america"></span>
    <span class="dot r5d25 north-america"></span>
    <span class="dot r5d26 north-america"></span>
    <span class="dot r5d27 north-america"></span>
    <span class="dot r5d28 north-america"></span>
    <span class="dot r5d29 north-america"></span>
    <span class="dot r5d30 water"></span>
    <span class="dot r5d31 water"></span>
    <span class="dot r5d32 water"></span>
    <span class="dot r5d33 water"></span>
    <span class="dot r5d34 water"></span>
    <span class="dot r5d35 water"></span>
    <span class="dot r5d36 water"></span>
    <span class="dot r5d37 water"></span>
    <span class="dot r5d38 water"></span>
    <span class="dot r5d39 water"></span>
    <span class="dot r5d40 water"></span>
    <span class="dot r5d41 water"></span>
    <span class="dot r5d42 water"></span>
    <span class="dot r5d43 asia"></span>
    <span class="dot r5d44 asia"></span>
    <span class="dot r5d45 asia"></span>
    <span class="dot r5d46 water"></span>
    <span class="dot r5d47 water"></span>
    <span class="dot r5d48 water"></span>
    <span class="dot r5d49 asia"></span>
    <span class="dot r5d50 asia"></span>
    <span class="dot r5d51 asia"></span>
    <span class="dot r5d52 asia"></span>
    <span class="dot r5d53 asia"></span>
    <span class="dot r5d54 asia"></span>
    <span class="dot r5d55 water"></span>
    <span class="dot r5d56 water"></span>
    <span class="dot r5d57 water"></span>
    <span class="dot r5d58 asia"></span>
    <span class="dot r5d59 asia"></span>
    <span class="dot r5d60 asia"></span>
    <span class="dot r5d61 water"></span>
    <span class="dot r5d62 water"></span>
    <span class="dot r5d63 water"></span>
    <span class="dot r5d64 water"></span>
    <span class="dot r5d65 water"></span>
    <span class="dot r5d66 water"></span>
    <span class="dot r5d67 water"></span>
    <span class="dot r5d68 water"></span>
  </div>
  <div class="row r6">
    <span class="dot r6d1 water"></span>
    <span class="dot r6d2 water"></span>
    <span class="dot r6d3 water"></span>
    <span class="dot r6d4 water"></span>
    <span class="dot r6d5 water"></span>
    <span class="dot r6d6 water"></span>
    <span class="dot r6d7 water"></span>
    <span class="dot r6d8 water"></span>
    <span class="dot r6d9 north-america"></span>
    <span class="dot r6d10 north-america"></span>
    <span class="dot r6d11 north-america"></span>
    <span class="dot r6d12 north-america"></span>
    <span class="dot r6d13 water"></span>
    <span class="dot r6d14 north-america"></span>
    <span class="dot r6d15 water"></span>
    <span class="dot r6d16 north-america"></span>
    <span class="dot r6d17 north-america"></span>
    <span class="dot r6d18 north-america"></span>
    <span class="dot r6d19 water"></span>
    <span class="dot r6d20 water"></span>
    <span class="dot r6d21 water"></span>
    <span class="dot r6d22 north-america"></span>
    <span class="dot r6d23 north-america"></span>
    <span class="dot r6d24 north-america"></span>
    <span class="dot r6d25 north-america"></span>
    <span class="dot r6d26 north-america"></span>
    <span class="dot r6d27 north-america"></span>
    <span class="dot r6d28 north-america"></span>
    <span class="dot r6d29 north-america"></span>
    <span class="dot r6d30 water"></span>
    <span class="dot r6d31 water"></span>
    <span class="dot r6d32 water"></span>
    <span class="dot r6d33 water"></span>
    <span class="dot r6d34 water"></span>
    <span class="dot r6d35 water"></span>
    <span class="dot r6d36 water"></span>
    <span class="dot r6d37 water"></span>
    <span class="dot r6d38 water"></span>
    <span class="dot r6d39 water"></span>
    <span class="dot r6d40 water"></span>
    <span class="dot r6d41 water"></span>
    <span class="dot r6d42 water"></span>
    <span class="dot r6d43 asia"></span>
    <span class="dot r6d44 water"></span>
    <span class="dot r6d45 water"></span>
    <span class="dot r6d46 asia"></span>
    <span class="dot r6d47 asia"></span>
    <span class="dot r6d48 asia"></span>
    <span class="dot r6d49 asia"></span>
    <span class="dot r6d50 asia"></span>
    <span class="dot r6d51 asia"></span>
    <span class="dot r6d52 asia"></span>
    <span class="dot r6d53 asia"></span>
    <span class="dot r6d54 asia"></span>
    <span class="dot r6d55 asia"></span>
    <span class="dot r6d56 asia"></span>
    <span class="dot r6d57 water"></span>
    <span class="dot r6d58 water"></span>
    <span class="dot r6d59 asia"></span>
    <span class="dot r6d60 water"></span>
    <span class="dot r6d61 water"></span>
    <span class="dot r6d62 water"></span>
    <span class="dot r6d63 water"></span>
    <span class="dot r6d64 water"></span>
    <span class="dot r6d65 water"></span>
    <span class="dot r6d66 water"></span>
    <span class="dot r6d67 water"></span>
    <span class="dot r6d68 water"></span>
  </div>
  <div class="row r7">
    <span class="dot r7d1 water"></span>
    <span class="dot r7d2 north-america"></span>
    <span class="dot r7d3 north-america"></span>
    <span class="dot r7d4 north-america"></span>
    <span class="dot r7d5 north-america"></span>
    <span class="dot r7d6 north-america"></span>
    <span class="dot r7d7 north-america"></span>
    <span class="dot r7d8 north-america"></span>
    <span class="dot r7d9 north-america"></span>
    <span class="dot r7d10 north-america"></span>
    <span class="dot r7d11 north-america"></span>
    <span class="dot r7d12 north-america"></span>
    <span class="dot r7d13 north-america"></span>
    <span class="dot r7d14 north-america"></span>
    <span class="dot r7d15 north-america"></span>
    <span class="dot r7d16 north-america"></span>
    <span class="dot r7d17 north-america"></span>
    <span class="dot r7d18 north-america"></span>
    <span class="dot r7d19 north-america"></span>
    <span class="dot r7d20 water"></span>
    <span class="dot r7d21 water"></span>
    <span class="dot r7d22 north-america"></span>
    <span class="dot r7d23 north-america"></span>
    <span class="dot r7d24 north-america"></span>
    <span class="dot r7d25 north-america"></span>
    <span class="dot r7d26 north-america"></span>
    <span class="dot r7d27 north-america"></span>
    <span class="dot r7d28 north-america"></span>
    <span class="dot r7d29 water"></span>
    <span class="dot r7d30 water"></span>
    <span class="dot r7d31 water"></span>
    <span class="dot r7d32 water"></span>
    <span class="dot r7d33 water"></span>
    <span class="dot r7d34 water"></span>
    <span class="dot r7d35 water"></span>
    <span class="dot r7d36 europe"></span>
    <span class="dot r7d37 europe"></span>
    <span class="dot r7d38 europe"></span>
    <span class="dot r7d39 water"></span>
    <span class="dot r7d40 water"></span>
    <span class="dot r7d41 water"></span>
    <span class="dot r7d42 water"></span>
    <span class="dot r7d43 water"></span>
    <span class="dot r7d44 asia"></span>
    <span class="dot r7d45 asia"></span>
    <span class="dot r7d46 asia"></span>
    <span class="dot r7d47 asia"></span>
    <span class="dot r7d48 asia"></span>
    <span class="dot r7d49 asia"></span>
    <span class="dot r7d50 asia"></span>
    <span class="dot r7d51 asia"></span>
    <span class="dot r7d52 asia"></span>
    <span class="dot r7d53 asia"></span>
    <span class="dot r7d54 asia"></span>
    <span class="dot r7d55 asia"></span>
    <span class="dot r7d56 asia"></span>
    <span class="dot r7d57 asia"></span>
    <span class="dot r7d58 asia"></span>
    <span class="dot r7d59 asia"></span>
    <span class="dot r7d60 asia"></span>
    <span class="dot r7d61 asia"></span>
    <span class="dot r7d62 asia"></span>
    <span class="dot r7d63 water"></span>
    <span class="dot r7d64 asia"></span>
    <span class="dot r7d65 asia"></span>
    <span class="dot r7d66 asia"></span>
    <span class="dot r7d67 water"></span>
    <span class="dot r7d68 water"></span>
  </div>
  <div class="row r8">
    <span class="dot r8d1 north-america"></span>
    <span class="dot r8d2 north-america"></span>
    <span class="dot r8d3 north-america"></span>
    <span class="dot r8d4 north-america"></span>
    <span class="dot r8d5 north-america"></span>
    <span class="dot r8d6 north-america"></span>
    <span class="dot r8d7 north-america"></span>
    <span class="dot r8d8 north-america"></span>
    <span class="dot r8d9 north-america"></span>
    <span class="dot r8d10 north-america"></span>
    <span class="dot r8d11 north-america"></span>
    <span class="dot r8d12 north-america"></span>
    <span class="dot r8d13 north-america"></span>
    <span class="dot r8d14 north-america"></span>
    <span class="dot r8d15 north-america"></span>
    <span class="dot r8d16 north-america"></span>
    <span class="dot r8d17 north-america"></span>
    <span class="dot r8d18 water"></span>
    <span class="dot r8d19 north-america"></span>
    <span class="dot r8d20 water"></span>
    <span class="dot r8d21 water"></span>
    <span class="dot r8d22 north-america"></span>
    <span class="dot r8d23 north-america"></span>
    <span class="dot r8d24 north-america"></span>
    <span class="dot r8d25 north-america"></span>
    <span class="dot r8d26 north-america"></span>
    <span class="dot r8d27 north-america"></span>
    <span class="dot r8d28 water"></span>
    <span class="dot r8d29 water"></span>
    <span class="dot r8d30 water"></span>
    <span class="dot r8d31 water"></span>
    <span class="dot r8d32 water"></span>
    <span class="dot r8d33 water"></span>
    <span class="dot r8d34 water"></span>
    <span class="dot r8d35 europe"></span>
    <span class="dot r8d36 europe"></span>
    <span class="dot r8d37 europe"></span>
    <span class="dot r8d38 europe"></span>
    <span class="dot r8d39 europe"></span>
    <span class="dot r8d40 europe"></span>
    <span class="dot r8d41 water"></span>
    <span class="dot r8d42 asia"></span>
    <span class="dot r8d43 asia"></span>
    <span class="dot r8d44 asia"></span>
    <span class="dot r8d45 asia"></span>
    <span class="dot r8d46 asia"></span>
    <span class="dot r8d47 asia"></span>
    <span class="dot r8d48 asia"></span>
    <span class="dot r8d49 asia"></span>
    <span class="dot r8d50 asia"></span>
    <span class="dot r8d51 asia"></span>
    <span class="dot r8d52 asia"></span>
    <span class="dot r8d53 asia"></span>
    <span class="dot r8d54 asia"></span>
    <span class="dot r8d55 asia"></span>
    <span class="dot r8d56 asia"></span>
    <span class="dot r8d57 asia"></span>
    <span class="dot r8d58 asia"></span>
    <span class="dot r8d59 asia"></span>
    <span class="dot r8d60 asia"></span>
    <span class="dot r8d61 asia"></span>
    <span class="dot r8d62 asia"></span>
    <span class="dot r8d63 asia"></span>
    <span class="dot r8d64 asia"></span>
    <span class="dot r8d65 asia"></span>
    <span class="dot r8d66 asia"></span>
    <span class="dot r8d67 asia"></span>
    <span class="dot r8d68 water"></span>
  </div>
  <div class="row r9">
    <span class="dot r9d1 water"></span>
    <span class="dot r9d2 north-america"></span>
    <span class="dot r9d3 north-america"></span>
    <span class="dot r9d4 north-america"></span>
    <span class="dot r9d5 north-america"></span>
    <span class="dot r9d6 north-america"></span>
    <span class="dot r9d7 north-america"></span>
    <span class="dot r9d8 north-america"></span>
    <span class="dot r9d9 north-america"></span>
    <span class="dot r9d10 north-america"></span>
    <span class="dot r9d11 north-america"></span>
    <span class="dot r9d12 north-america"></span>
    <span class="dot r9d13 north-america"></span>
    <span class="dot r9d14 north-america"></span>
    <span class="dot r9d15 north-america"></span>
    <span class="dot r9d16 north-america"></span>
    <span class="dot r9d17 north-america"></span>
    <span class="dot r9d18 north-america"></span>
    <span class="dot r9d19 north-america"></span>
    <span class="dot r9d20 north-america"></span>
    <span class="dot r9d21 water"></span>
    <span class="dot r9d22 water"></span>
    <span class="dot r9d23 north-america"></span>
    <span class="dot r9d24 north-america"></span>
    <span class="dot r9d25 north-america"></span>
    <span class="dot r9d26 water"></span>
    <span class="dot r9d27 water"></span>
    <span class="dot r9d28 north-america"></span>
    <span class="dot r9d29 north-america"></span>
    <span class="dot r9d30 water"></span>
    <span class="dot r9d31 water"></span>
    <span class="dot r9d32 water"></span>
    <span class="dot r9d33 water"></span>
    <span class="dot r9d34 water"></span>
    <span class="dot r9d35 europe"></span>
    <span class="dot r9d36 europe"></span>
    <span class="dot r9d37 europe"></span>
    <span class="dot r9d38 europe"></span>
    <span class="dot r9d39 europe"></span>
    <span class="dot r9d40 europe"></span>
    <span class="dot r9d41 europe"></span>
    <span class="dot r9d42 asia"></span>
    <span class="dot r9d43 asia"></span>
    <span class="dot r9d44 asia"></span>
    <span class="dot r9d45 asia"></span>
    <span class="dot r9d46 asia"></span>
    <span class="dot r9d47 asia"></span>
    <span class="dot r9d48 asia"></span>
    <span class="dot r9d49 asia"></span>
    <span class="dot r9d50 asia"></span>
    <span class="dot r9d51 asia"></span>
    <span class="dot r9d52 asia"></span>
    <span class="dot r9d53 asia"></span>
    <span class="dot r9d54 asia"></span>
    <span class="dot r9d55 asia"></span>
    <span class="dot r9d56 asia"></span>
    <span class="dot r9d57 asia"></span>
    <span class="dot r9d58 asia"></span>
    <span class="dot r9d59 asia"></span>
    <span class="dot r9d60 asia"></span>
    <span class="dot r9d61 asia"></span>
    <span class="dot r9d62 asia"></span>
    <span class="dot r9d63 asia"></span>
    <span class="dot r9d64 asia"></span>
    <span class="dot r9d65 asia"></span>
    <span class="dot r9d66 asia"></span>
    <span class="dot r9d67 asia"></span>
    <span class="dot r9d68 asia"></span>
  </div>
  <div class="row r10">
    <span class="dot r10d1 north-america"></span>
    <span class="dot r10d2 north-america"></span>
    <span class="dot r10d3 north-america"></span>
    <span class="dot r10d4 north-america"></span>
    <span class="dot r10d5 north-america"></span>
    <span class="dot r10d6 north-america"></span>
    <span class="dot r10d7 north-america"></span>
    <span class="dot r10d8 north-america"></span>
    <span class="dot r10d9 north-america"></span>
    <span class="dot r10d10 north-america"></span>
    <span class="dot r10d11 north-america"></span>
    <span class="dot r10d12 north-america"></span>
    <span class="dot r10d13 north-america"></span>
    <span class="dot r10d14 north-america"></span>
    <span class="dot r10d15 north-america"></span>
    <span class="dot r10d16 water"></span>
    <span class="dot r10d17 water"></span>
    <span class="dot r10d18 north-america"></span>
    <span class="dot r10d19 north-america"></span>
    <span class="dot r10d20 north-america"></span>
    <span class="dot r10d21 water"></span>
    <span class="dot r10d22 water"></span>
    <span class="dot r10d23 north-america"></span>
    <span class="dot r10d24 north-america"></span>
    <span class="dot r10d25 water"></span>
    <span class="dot r10d26 water"></span>
    <span class="dot r10d27 water"></span>
    <span class="dot r10d28 water"></span>
    <span class="dot r10d29 water"></span>
    <span class="dot r10d30 water"></span>
    <span class="dot r10d31 water"></span>
    <span class="dot r10d32 water"></span>
    <span class="dot r10d33 water"></span>
    <span class="dot r10d34 europe"></span>
    <span class="dot r10d35 europe"></span>
    <span class="dot r10d36 water"></span>
    <span class="dot r10d37 europe"></span>
    <span class="dot r10d38 europe"></span>
    <span class="dot r10d39 europe"></span>
    <span class="dot r10d40 europe"></span>
    <span class="dot r10d41 europe"></span>
    <span class="dot r10d42 asia"></span>
    <span class="dot r10d43 asia"></span>
    <span class="dot r10d44 asia"></span>
    <span class="dot r10d45 asia"></span>
    <span class="dot r10d46 asia"></span>
    <span class="dot r10d47 asia"></span>
    <span class="dot r10d48 asia"></span>
    <span class="dot r10d49 asia"></span>
    <span class="dot r10d50 asia"></span>
    <span class="dot r10d51 asia"></span>
    <span class="dot r10d52 asia"></span>
    <span class="dot r10d53 asia"></span>
    <span class="dot r10d54 asia"></span>
    <span class="dot r10d55 asia"></span>
    <span class="dot r10d56 asia"></span>
    <span class="dot r10d57 asia"></span>
    <span class="dot r10d58 asia"></span>
    <span class="dot r10d59 asia"></span>
    <span class="dot r10d60 asia"></span>
    <span class="dot r10d61 asia"></span>
    <span class="dot r10d62 asia"></span>
    <span class="dot r10d63 asia"></span>
    <span class="dot r10d64 asia"></span>
    <span class="dot r10d65 asia"></span>
    <span class="dot r10d66 water"></span>
    <span class="dot r10d67 water"></span>
    <span class="dot r10d68 asia"></span>
  </div>
  <div class="row r11">
    <span class="dot r11d1 water"></span>
    <span class="dot r11d2 north-america"></span>
    <span class="dot r11d3 north-america"></span>
    <span class="dot r11d4 north-america"></span>
    <span class="dot r11d5 water"></span>
    <span class="dot r11d6 water"></span>
    <span class="dot r11d7 north-america"></span>
    <span class="dot r11d8 north-america"></span>
    <span class="dot r11d9 north-america"></span>
    <span class="dot r11d10 north-america"></span>
    <span class="dot r11d11 north-america"></span>
    <span class="dot r11d12 north-america"></span>
    <span class="dot r11d13 north-america"></span>
    <span class="dot r11d14 north-america"></span>
    <span class="dot r11d15 north-america"></span>
    <span class="dot r11d16 water"></span>
    <span class="dot r11d17 water"></span>
    <span class="dot r11d18 north-america"></span>
    <span class="dot r11d19 north-america"></span>
    <span class="dot r11d20 north-america"></span>
    <span class="dot r11d21 water"></span>
    <span class="dot r11d22 water"></span>
    <span class="dot r11d23 water"></span>
    <span class="dot r11d24 north-america"></span>
    <span class="dot r11d25 water"></span>
    <span class="dot r11d26 water"></span>
    <span class="dot r11d27 water"></span>
    <span class="dot r11d28 water"></span>
    <span class="dot r11d29 water"></span>
    <span class="dot r11d30 water"></span>
    <span class="dot r11d31 water"></span>
    <span class="dot r11d32 europe"></span>
    <span class="dot r11d33 water"></span>
    <span class="dot r11d34 europe"></span>
    <span class="dot r11d35 europe"></span>
    <span class="dot r11d36 water"></span>
    <span class="dot r11d37 europe"></span>
    <span class="dot r11d38 europe"></span>
    <span class="dot r11d39 europe"></span>
    <span class="dot r11d40 europe"></span>
    <span class="dot r11d41 europe"></span>
    <span class="dot r11d42 europe"></span>
    <span class="dot r11d43 asia"></span>
    <span class="dot r11d44 asia"></span>
    <span class="dot r11d45 asia"></span>
    <span class="dot r11d46 asia"></span>
    <span class="dot r11d47 asia"></span>
    <span class="dot r11d48 asia"></span>
    <span class="dot r11d49 asia"></span>
    <span class="dot r11d50 asia"></span>
    <span class="dot r11d51 asia"></span>
    <span class="dot r11d52 asia"></span>
    <span class="dot r11d53 asia"></span>
    <span class="dot r11d54 asia"></span>
    <span class="dot r11d55 asia"></span>
    <span class="dot r11d56 asia"></span>
    <span class="dot r11d57 asia"></span>
    <span class="dot r11d58 asia"></span>
    <span class="dot r11d59 asia"></span>
    <span class="dot r11d60 asia"></span>
    <span class="dot r11d61 water"></span>
    <span class="dot r11d62 asia"></span>
    <span class="dot r11d63 asia"></span>
    <span class="dot r11d64 water"></span>
    <span class="dot r11d65 water"></span>
    <span class="dot r11d66 water"></span>
    <span class="dot r11d67 water"></span>
    <span class="dot r11d68 water"></span>
  </div>
  <div class="row r12">
    <span class="dot r12d1 water"></span>
    <span class="dot r12d2 north-america"></span>
    <span class="dot r12d3 water"></span>
    <span class="dot r12d4 water"></span>
    <span class="dot r12d5 water"></span>
    <span class="dot r12d6 water"></span>
    <span class="dot r12d7 north-america"></span>
    <span class="dot r12d8 north-america"></span>
    <span class="dot r12d9 north-america"></span>
    <span class="dot r12d10 north-america"></span>
    <span class="dot r12d11 north-america"></span>
    <span class="dot r12d12 north-america"></span>
    <span class="dot r12d13 north-america"></span>
    <span class="dot r12d14 north-america"></span>
    <span class="dot r12d15 north-america"></span>
    <span class="dot r12d16 north-america"></span>
    <span class="dot r12d17 north-america"></span>
    <span class="dot r12d18 north-america"></span>
    <span class="dot r12d19 north-america"></span>
    <span class="dot r12d20 north-america"></span>
    <span class="dot r12d21 north-america"></span>
    <span class="dot r12d22 water"></span>
    <span class="dot r12d23 water"></span>
    <span class="dot r12d24 water"></span>
    <span class="dot r12d25 water"></span>
    <span class="dot r12d26 water"></span>
    <span class="dot r12d27 water"></span>
    <span class="dot r12d28 water"></span>
    <span class="dot r12d29 water"></span>
    <span class="dot r12d30 water"></span>
    <span class="dot r12d31 europe"></span>
    <span class="dot r12d32 europe"></span>
    <span class="dot r12d33 water"></span>
    <span class="dot r12d34 water"></span>
    <span class="dot r12d35 europe"></span>
    <span class="dot r12d36 europe"></span>
    <span class="dot r12d37 europe"></span>
    <span class="dot r12d38 europe"></span>
    <span class="dot r12d39 europe"></span>
    <span class="dot r12d40 europe"></span>
    <span class="dot r12d41 europe"></span>
    <span class="dot r12d42 europe"></span>
    <span class="dot r12d43 asia"></span>
    <span class="dot r12d44 asia"></span>
    <span class="dot r12d45 asia"></span>
    <span class="dot r12d46 asia"></span>
    <span class="dot r12d47 asia"></span>
    <span class="dot r12d48 asia"></span>
    <span class="dot r12d49 asia"></span>
    <span class="dot r12d50 asia"></span>
    <span class="dot r12d51 asia"></span>
    <span class="dot r12d52 asia"></span>
    <span class="dot r12d53 asia"></span>
    <span class="dot r12d54 asia"></span>
    <span class="dot r12d55 asia"></span>
    <span class="dot r12d56 asia"></span>
    <span class="dot r12d57 asia"></span>
    <span class="dot r12d58 asia"></span>
    <span class="dot r12d59 asia"></span>
    <span class="dot r12d60 water"></span>
    <span class="dot r12d61 water"></span>
    <span class="dot r12d62 asia"></span>
    <span class="dot r12d63 asia"></span>
    <span class="dot r12d64 water"></span>
    <span class="dot r12d65 water"></span>
    <span class="dot r12d66 water"></span>
    <span class="dot r12d67 water"></span>
    <span class="dot r12d68 water"></span>
  </div>
  <div class="row r13">
    <span class="dot r13d1 north-america"></span>
    <span class="dot r13d2 water"></span>
    <span class="dot r13d3 water"></span>
    <span class="dot r13d4 water"></span>
    <span class="dot r13d5 water"></span>
    <span class="dot r13d6 water"></span>
    <span class="dot r13d7 water"></span>
    <span class="dot r13d8 north-america"></span>
    <span class="dot r13d9 north-america"></span>
    <span class="dot r13d10 north-america"></span>
    <span class="dot r13d11 north-america"></span>
    <span class="dot r13d12 north-america"></span>
    <span class="dot r13d13 north-america"></span>
    <span class="dot r13d14 north-america"></span>
    <span class="dot r13d15 north-america"></span>
    <span class="dot r13d16 north-america"></span>
    <span class="dot r13d17 north-america"></span>
    <span class="dot r13d18 north-america"></span>
    <span class="dot r13d19 north-america"></span>
    <span class="dot r13d20 north-america"></span>
    <span class="dot r13d21 north-america"></span>
    <span class="dot r13d22 north-america"></span>
    <span class="dot r13d23 water"></span>
    <span class="dot r13d24 water"></span>
    <span class="dot r13d25 water"></span>
    <span class="dot r13d26 water"></span>
    <span class="dot r13d27 water"></span>
    <span class="dot r13d28 water"></span>
    <span class="dot r13d29 water"></span>
    <span class="dot r13d30 water"></span>
    <span class="dot r13d31 europe"></span>
    <span class="dot r13d32 europe"></span>
    <span class="dot r13d33 europe"></span>
    <span class="dot r13d34 europe"></span>
    <span class="dot r13d35 europe"></span>
    <span class="dot r13d36 europe"></span>
    <span class="dot r13d37 europe"></span>
    <span class="dot r13d38 europe"></span>
    <span class="dot r13d39 europe"></span>
    <span class="dot r13d40 europe"></span>
    <span class="dot r13d41 europe"></span>
    <span class="dot r13d42 asia"></span>
    <span class="dot r13d43 asia"></span>
    <span class="dot r13d44 asia"></span>
    <span class="dot r13d45 asia"></span>
    <span class="dot r13d46 asia"></span>
    <span class="dot r13d47 asia"></span>
    <span class="dot r13d48 asia"></span>
    <span class="dot r13d49 asia"></span>
    <span class="dot r13d50 asia"></span>
    <span class="dot r13d51 asia"></span>
    <span class="dot r13d52 asia"></span>
    <span class="dot r13d53 asia"></span>
    <span class="dot r13d54 asia"></span>
    <span class="dot r13d55 asia"></span>
    <span class="dot r13d56 asia"></span>
    <span class="dot r13d57 asia"></span>
    <span class="dot r13d58 asia"></span>
    <span class="dot r13d59 asia"></span>
    <span class="dot r13d60 water"></span>
    <span class="dot r13d61 water"></span>
    <span class="dot r13d62 asia"></span>
    <span class="dot r13d63 water"></span>
    <span class="dot r13d64 water"></span>
    <span class="dot r13d65 water"></span>
    <span class="dot r13d66 water"></span>
    <span class="dot r13d67 water"></span>
    <span class="dot r13d68 water"></span>
  </div>
  <div class="row r14">
    <span class="dot r14d1 water"></span>
    <span class="dot r14d2 water"></span>
    <span class="dot r14d3 water"></span>
    <span class="dot r14d4 water"></span>
    <span class="dot r14d5 water"></span>
    <span class="dot r14d6 water"></span>
    <span class="dot r14d7 water"></span>
    <span class="dot r14d8 water"></span>
    <span class="dot r14d9 north-america"></span>
    <span class="dot r14d10 north-america"></span>
    <span class="dot r14d11 north-america"></span>
    <span class="dot r14d12 north-america"></span>
    <span class="dot r14d13 north-america"></span>
    <span class="dot r14d14 north-america"></span>
    <span class="dot r14d15 north-america"></span>
    <span class="dot r14d16 north-america"></span>
    <span class="dot r14d17 north-america"></span>
    <span class="dot r14d18 north-america"></span>
    <span class="dot r14d19 north-america"></span>
    <span class="dot r14d20 north-america"></span>
    <span class="dot r14d21 north-america"></span>
    <span class="dot r14d22 north-america"></span>
    <span class="dot r14d23 water"></span>
    <span class="dot r14d24 water"></span>
    <span class="dot r14d25 water"></span>
    <span class="dot r14d26 water"></span>
    <span class="dot r14d27 water"></span>
    <span class="dot r14d28 water"></span>
    <span class="dot r14d29 water"></span>
    <span class="dot r14d30 water"></span>
    <span class="dot r14d31 water"></span>
    <span class="dot r14d32 europe"></span>
    <span class="dot r14d33 europe"></span>
    <span class="dot r14d34 europe"></span>
    <span class="dot r14d35 europe"></span>
    <span class="dot r14d36 europe"></span>
    <span class="dot r14d37 europe"></span>
    <span class="dot r14d38 europe"></span>
    <span class="dot r14d39 europe"></span>
    <span class="dot r14d40 europe"></span>
    <span class="dot r14d41 europe"></span>
    <span class="dot r14d42 asia"></span>
    <span class="dot r14d43 asia"></span>
    <span class="dot r14d44 asia"></span>
    <span class="dot r14d45 asia"></span>
    <span class="dot r14d46 asia"></span>
    <span class="dot r14d47 asia"></span>
    <span class="dot r14d48 asia"></span>
    <span class="dot r14d49 asia"></span>
    <span class="dot r14d50 asia"></span>
    <span class="dot r14d51 asia"></span>
    <span class="dot r14d52 asia"></span>
    <span class="dot r14d53 asia"></span>
    <span class="dot r14d54 asia"></span>
    <span class="dot r14d55 asia"></span>
    <span class="dot r14d56 asia"></span>
    <span class="dot r14d57 asia"></span>
    <span class="dot r14d58 asia"></span>
    <span class="dot r14d59 asia"></span>
    <span class="dot r14d60 water"></span>
    <span class="dot r14d61 water"></span>
    <span class="dot r14d62 asia"></span>
    <span class="dot r14d63 water"></span>
    <span class="dot r14d64 water"></span>
    <span class="dot r14d65 water"></span>
    <span class="dot r14d66 water"></span>
    <span class="dot r14d67 water"></span>
    <span class="dot r14d68 water"></span>
  </div>
  <div class="row r15">
    <span class="dot r15d1 water"></span>
    <span class="dot r15d2 water"></span>
    <span class="dot r15d3 water"></span>
    <span class="dot r15d4 water"></span>
    <span class="dot r15d5 water"></span>
    <span class="dot r15d6 water"></span>
    <span class="dot r15d7 water"></span>
    <span class="dot r15d8 water"></span>
    <span class="dot r15d9 north-america"></span>
    <span class="dot r15d10 north-america"></span>
    <span class="dot r15d11 north-america"></span>
    <span class="dot r15d12 north-america"></span>
    <span class="dot r15d13 north-america"></span>
    <span class="dot r15d14 north-america"></span>
    <span class="dot r15d15 north-america"></span>
    <span class="dot r15d16 north-america"></span>
    <span class="dot r15d17 north-america"></span>
    <span class="dot r15d18 north-america"></span>
    <span class="dot r15d19 north-america"></span>
    <span class="dot r15d20 north-america"></span>
    <span class="dot r15d21 north-america"></span>
    <span class="dot r15d22 water"></span>
    <span class="dot r15d23 water"></span>
    <span class="dot r15d24 water"></span>
    <span class="dot r15d25 water"></span>
    <span class="dot r15d26 water"></span>
    <span class="dot r15d27 water"></span>
    <span class="dot r15d28 water"></span>
    <span class="dot r15d29 water"></span>
    <span class="dot r15d30 water"></span>
    <span class="dot r15d31 water"></span>
    <span class="dot r15d32 europe"></span>
    <span class="dot r15d33 europe"></span>
    <span class="dot r15d34 europe"></span>
    <span class="dot r15d35 europe"></span>
    <span class="dot r15d36 europe"></span>
    <span class="dot r15d37 europe"></span>
    <span class="dot r15d38 water"></span>
    <span class="dot r15d39 water"></span>
    <span class="dot r15d40 europe"></span>
    <span class="dot r15d41 europe"></span>
    <span class="dot r15d42 water"></span>
    <span class="dot r15d43 asia"></span>
    <span class="dot r15d44 asia"></span>
    <span class="dot r15d45 asia"></span>
    <span class="dot r15d46 asia"></span>
    <span class="dot r15d47 asia"></span>
    <span class="dot r15d48 asia"></span>
    <span class="dot r15d49 asia"></span>
    <span class="dot r15d50 asia"></span>
    <span class="dot r15d51 asia"></span>
    <span class="dot r15d52 asia"></span>
    <span class="dot r15d53 asia"></span>
    <span class="dot r15d54 asia"></span>
    <span class="dot r15d55 asia"></span>
    <span class="dot r15d56 asia"></span>
    <span class="dot r15d57 asia"></span>
    <span class="dot r15d58 asia"></span>
    <span class="dot r15d59 asia"></span>
    <span class="dot r15d60 asia"></span>
    <span class="dot r15d61 water"></span>
    <span class="dot r15d62 water"></span>
    <span class="dot r15d63 water"></span>
    <span class="dot r15d64 water"></span>
    <span class="dot r15d65 water"></span>
    <span class="dot r15d66 water"></span>
    <span class="dot r15d67 water"></span>
    <span class="dot r15d68 water"></span>
  </div>
  <div class="row r16">
    <span class="dot r16d1 water"></span>
    <span class="dot r16d2 water"></span>
    <span class="dot r16d3 water"></span>
    <span class="dot r16d4 water"></span>
    <span class="dot r16d5 water"></span>
    <span class="dot r16d6 water"></span>
    <span class="dot r16d7 water"></span>
    <span class="dot r16d8 water"></span>
    <span class="dot r16d9 north-america"></span>
    <span class="dot r16d10 north-america"></span>
    <span class="dot r16d11 north-america"></span>
    <span class="dot r16d12 north-america"></span>
    <span class="dot r16d13 north-america"></span>
    <span class="dot r16d14 north-america"></span>
    <span class="dot r16d15 north-america"></span>
    <span class="dot r16d16 north-america"></span>
    <span class="dot r16d17 north-america"></span>
    <span class="dot r16d18 north-america"></span>
    <span class="dot r16d19 north-america"></span>
    <span class="dot r16d20 water"></span>
    <span class="dot r16d21 water"></span>
    <span class="dot r16d22 water"></span>
    <span class="dot r16d23 water"></span>
    <span class="dot r16d24 water"></span>
    <span class="dot r16d25 water"></span>
    <span class="dot r16d26 water"></span>
    <span class="dot r16d27 water"></span>
    <span class="dot r16d28 water"></span>
    <span class="dot r16d29 water"></span>
    <span class="dot r16d30 water"></span>
    <span class="dot r16d31 europe"></span>
    <span class="dot r16d32 europe"></span>
    <span class="dot r16d33 europe"></span>
    <span class="dot r16d34 water"></span>
    <span class="dot r16d35 europe"></span>
    <span class="dot r16d36 europe"></span>
    <span class="dot r16d37 europe"></span>
    <span class="dot r16d38 europe"></span>
    <span class="dot r16d39 europe"></span>
    <span class="dot r16d40 europe"></span>
    <span class="dot r16d41 europe"></span>
    <span class="dot r16d42 water"></span>
    <span class="dot r16d43 asia"></span>
    <span class="dot r16d44 asia"></span>
    <span class="dot r16d45 asia"></span>
    <span class="dot r16d46 asia"></span>
    <span class="dot r16d47 asia"></span>
    <span class="dot r16d48 asia"></span>
    <span class="dot r16d49 asia"></span>
    <span class="dot r16d50 asia"></span>
    <span class="dot r16d51 asia"></span>
    <span class="dot r16d52 asia"></span>
    <span class="dot r16d53 asia"></span>
    <span class="dot r16d54 asia"></span>
    <span class="dot r16d55 asia"></span>
    <span class="dot r16d56 asia"></span>
    <span class="dot r16d57 water"></span>
    <span class="dot r16d58 water"></span>
    <span class="dot r16d59 asia"></span>
    <span class="dot r16d60 water"></span>
    <span class="dot r16d61 water"></span>
    <span class="dot r16d62 water"></span>
    <span class="dot r16d63 water"></span>
    <span class="dot r16d64 water"></span>
    <span class="dot r16d65 water"></span>
    <span class="dot r16d66 water"></span>
    <span class="dot r16d67 water"></span>
    <span class="dot r16d68 water"></span>
  </div>
  <div class="row r17">
    <span class="dot r17d1 water"></span>
    <span class="dot r17d2 water"></span>
    <span class="dot r17d3 water"></span>
    <span class="dot r17d4 water"></span>
    <span class="dot r17d5 water"></span>
    <span class="dot r17d6 water"></span>
    <span class="dot r17d7 water"></span>
    <span class="dot r17d8 water"></span>
    <span class="dot r17d9 water"></span>
    <span class="dot r17d10 north-america"></span>
    <span class="dot r17d11 north-america"></span>
    <span class="dot r17d12 north-america"></span>
    <span class="dot r17d13 north-america"></span>
    <span class="dot r17d14 north-america"></span>
    <span class="dot r17d15 north-america"></span>
    <span class="dot r17d16 north-america"></span>
    <span class="dot r17d17 north-america"></span>
    <span class="dot r17d18 north-america"></span>
    <span class="dot r17d19 water"></span>
    <span class="dot r17d20 water"></span>
    <span class="dot r17d21 water"></span>
    <span class="dot r17d22 water"></span>
    <span class="dot r17d23 water"></span>
    <span class="dot r17d24 water"></span>
    <span class="dot r17d25 water"></span>
    <span class="dot r17d26 water"></span>
    <span class="dot r17d27 water"></span>
    <span class="dot r17d28 water"></span>
    <span class="dot r17d29 water"></span>
    <span class="dot r17d30 water"></span>
    <span class="dot r17d31 europe"></span>
    <span class="dot r17d32 europe"></span>
    <span class="dot r17d33 europe"></span>
    <span class="dot r17d34 europe"></span>
    <span class="dot r17d35 water"></span>
    <span class="dot r17d36 water"></span>
    <span class="dot r17d37 water"></span>
    <span class="dot r17d38 water"></span>
    <span class="dot r17d39 asia"></span>
    <span class="dot r17d40 asia"></span>
    <span class="dot r17d41 asia"></span>
    <span class="dot r17d42 asia"></span>
    <span class="dot r17d43 asia"></span>
    <span class="dot r17d44 asia"></span>
    <span class="dot r17d45 asia"></span>
    <span class="dot r17d46 asia"></span>
    <span class="dot r17d47 asia"></span>
    <span class="dot r17d48 asia"></span>
    <span class="dot r17d49 asia"></span>
    <span class="dot r17d50 asia"></span>
    <span class="dot r17d51 asia"></span>
    <span class="dot r17d52 asia"></span>
    <span class="dot r17d53 asia"></span>
    <span class="dot r17d54 asia"></span>
    <span class="dot r17d55 asia"></span>
    <span class="dot r17d56 asia"></span>
    <span class="dot r17d57 asia"></span>
    <span class="dot r17d58 asia"></span>
    <span class="dot r17d59 asia"></span>
    <span class="dot r17d60 water"></span>
    <span class="dot r17d61 water"></span>
    <span class="dot r17d62 water"></span>
    <span class="dot r17d63 water"></span>
    <span class="dot r17d64 water"></span>
    <span class="dot r17d65 water"></span>
    <span class="dot r17d66 water"></span>
    <span class="dot r17d67 water"></span>
    <span class="dot r17d68 water"></span>
  </div>
  <div class="row r18">
    <span class="dot r18d1 water"></span>
    <span class="dot r18d2 water"></span>
    <span class="dot r18d3 water"></span>
    <span class="dot r18d4 water"></span>
    <span class="dot r18d5 water"></span>
    <span class="dot r18d6 water"></span>
    <span class="dot r18d7 water"></span>
    <span class="dot r18d8 water"></span>
    <span class="dot r18d9 water"></span>
    <span class="dot r18d10 water"></span>
    <span class="dot r18d11 north-america"></span>
    <span class="dot r18d12 north-america"></span>
    <span class="dot r18d13 north-america"></span>
    <span class="dot r18d14 north-america"></span>
    <span class="dot r18d15 north-america"></span>
    <span class="dot r18d16 north-america"></span>
    <span class="dot r18d17 north-america"></span>
    <span class="dot r18d18 water"></span>
    <span class="dot r18d19 water"></span>
    <span class="dot r18d20 water"></span>
    <span class="dot r18d21 water"></span>
    <span class="dot r18d22 water"></span>
    <span class="dot r18d23 water"></span>
    <span class="dot r18d24 water"></span>
    <span class="dot r18d25 water"></span>
    <span class="dot r18d26 water"></span>
    <span class="dot r18d27 water"></span>
    <span class="dot r18d28 water"></span>
    <span class="dot r18d29 water"></span>
    <span class="dot r18d30 water"></span>
    <span class="dot r18d31 europe"></span>
    <span class="dot r18d32 europe"></span>
    <span class="dot r18d33 europe"></span>
    <span class="dot r18d34 europe"></span>
    <span class="dot r18d35 europe"></span>
    <span class="dot r18d36 europe"></span>
    <span class="dot r18d37 asia"></span>
    <span class="dot r18d38 asia"></span>
    <span class="dot r18d39 asia"></span>
    <span class="dot r18d40 asia"></span>
    <span class="dot r18d41 asia"></span>
    <span class="dot r18d42 water"></span>
    <span class="dot r18d43 asia"></span>
    <span class="dot r18d44 asia"></span>
    <span class="dot r18d45 asia"></span>
    <span class="dot r18d46 asia"></span>
    <span class="dot r18d47 asia"></span>
    <span class="dot r18d48 asia"></span>
    <span class="dot r18d49 asia"></span>
    <span class="dot r18d50 asia"></span>
    <span class="dot r18d51 asia"></span>
    <span class="dot r18d52 asia"></span>
    <span class="dot r18d53 asia"></span>
    <span class="dot r18d54 asia"></span>
    <span class="dot r18d55 asia"></span>
    <span class="dot r18d56 water"></span>
    <span class="dot r18d57 asia"></span>
    <span class="dot r18d58 water"></span>
    <span class="dot r18d59 water"></span>
    <span class="dot r18d60 water"></span>
    <span class="dot r18d61 water"></span>
    <span class="dot r18d62 water"></span>
    <span class="dot r18d63 water"></span>
    <span class="dot r18d64 water"></span>
    <span class="dot r18d65 water"></span>
    <span class="dot r18d66 water"></span>
    <span class="dot r18d67 water"></span>
    <span class="dot r18d68 water"></span>
  </div>
  <div class="row r19">
    <span class="dot r19d1 water"></span>
    <span class="dot r19d2 water"></span>
    <span class="dot r19d3 water"></span>
    <span class="dot r19d4 water"></span>
    <span class="dot r19d5 water"></span>
    <span class="dot r19d6 water"></span>
    <span class="dot r19d7 water"></span>
    <span class="dot r19d8 water"></span>
    <span class="dot r19d9 water"></span>
    <span class="dot r19d10 water"></span>
    <span class="dot r19d11 north-america"></span>
    <span class="dot r19d12 north-america"></span>
    <span class="dot r19d13 north-america"></span>
    <span class="dot r19d14 north-america"></span>
    <span class="dot r19d15 water"></span>
    <span class="dot r19d16 water"></span>
    <span class="dot r19d17 north-america"></span>
    <span class="dot r19d18 water"></span>
    <span class="dot r19d19 water"></span>
    <span class="dot r19d20 water"></span>
    <span class="dot r19d21 water"></span>
    <span class="dot r19d22 water"></span>
    <span class="dot r19d23 water"></span>
    <span class="dot r19d24 water"></span>
    <span class="dot r19d25 water"></span>
    <span class="dot r19d26 water"></span>
    <span class="dot r19d27 water"></span>
    <span class="dot r19d28 water"></span>
    <span class="dot r19d29 water"></span>
    <span class="dot r19d30 africa"></span>
    <span class="dot r19d31 africa"></span>
    <span class="dot r19d32 africa"></span>
    <span class="dot r19d33 africa"></span>
    <span class="dot r19d34 africa"></span>
    <span class="dot r19d35 africa"></span>
    <span class="dot r19d36 africa"></span>
    <span class="dot r19d37 africa"></span>
    <span class="dot r19d38 water"></span>
    <span class="dot r19d39 asia"></span>
    <span class="dot r19d40 asia"></span>
    <span class="dot r19d41 asia"></span>
    <span class="dot r19d42 asia"></span>
    <span class="dot r19d43 water"></span>
    <span class="dot r19d44 asia"></span>
    <span class="dot r19d45 asia"></span>
    <span class="dot r19d46 asia"></span>
    <span class="dot r19d47 asia"></span>
    <span class="dot r19d48 asia"></span>
    <span class="dot r19d49 asia"></span>
    <span class="dot r19d50 asia"></span>
    <span class="dot r19d51 asia"></span>
    <span class="dot r19d52 asia"></span>
    <span class="dot r19d53 asia"></span>
    <span class="dot r19d54 asia"></span>
    <span class="dot r19d55 asia"></span>
    <span class="dot r19d56 water"></span>
    <span class="dot r19d57 water"></span>
    <span class="dot r19d58 water"></span>
    <span class="dot r19d59 water"></span>
    <span class="dot r19d60 water"></span>
    <span class="dot r19d61 water"></span>
    <span class="dot r19d62 water"></span>
    <span class="dot r19d63 water"></span>
    <span class="dot r19d64 water"></span>
    <span class="dot r19d65 water"></span>
    <span class="dot r19d66 water"></span>
    <span class="dot r19d67 water"></span>
    <span class="dot r19d68 water"></span>
  </div>
  <div class="row r20">
    <span class="dot r20d1 water"></span>
    <span class="dot r20d2 north-america"></span>
    <span class="dot r20d3 north-america"></span>
    <span class="dot r20d4 water"></span>
    <span class="dot r20d5 water"></span>
    <span class="dot r20d6 water"></span>
    <span class="dot r20d7 water"></span>
    <span class="dot r20d8 water"></span>
    <span class="dot r20d9 water"></span>
    <span class="dot r20d10 water"></span>
    <span class="dot r20d11 water"></span>
    <span class="dot r20d12 water"></span>
    <span class="dot r20d13 north-america"></span>
    <span class="dot r20d14 north-america"></span>
    <span class="dot r20d15 water"></span>
    <span class="dot r20d16 north-america"></span>
    <span class="dot r20d17 north-america"></span>
    <span class="dot r20d18 water"></span>
    <span class="dot r20d19 water"></span>
    <span class="dot r20d20 water"></span>
    <span class="dot r20d21 water"></span>
    <span class="dot r20d22 water"></span>
    <span class="dot r20d23 water"></span>
    <span class="dot r20d24 water"></span>
    <span class="dot r20d25 water"></span>
    <span class="dot r20d26 water"></span>
    <span class="dot r20d27 water"></span>
    <span class="dot r20d28 water"></span>
    <span class="dot r20d29 africa"></span>
    <span class="dot r20d30 africa"></span>
    <span class="dot r20d31 africa"></span>
    <span class="dot r20d32 africa"></span>
    <span class="dot r20d33 africa"></span>
    <span class="dot r20d34 africa"></span>
    <span class="dot r20d35 africa"></span>
    <span class="dot r20d36 africa"></span>
    <span class="dot r20d37 africa"></span>
    <span class="dot r20d38 africa"></span>
    <span class="dot r20d39 water"></span>
    <span class="dot r20d40 asia"></span>
    <span class="dot r20d41 asia"></span>
    <span class="dot r20d42 asia"></span>
    <span class="dot r20d43 asia"></span>
    <span class="dot r20d44 water"></span>
    <span class="dot r20d45 water"></span>
    <span class="dot r20d46 asia"></span>
    <span class="dot r20d47 asia"></span>
    <span class="dot r20d48 asia"></span>
    <span class="dot r20d49 asia"></span>
    <span class="dot r20d50 asia"></span>
    <span class="dot r20d51 asia"></span>
    <span class="dot r20d52 asia"></span>
    <span class="dot r20d53 asia"></span>
    <span class="dot r20d54 asia"></span>
    <span class="dot r20d55 asia"></span>
    <span class="dot r20d56 water"></span>
    <span class="dot r20d57 water"></span>
    <span class="dot r20d58 water"></span>
    <span class="dot r20d59 water"></span>
    <span class="dot r20d60 water"></span>
    <span class="dot r20d61 water"></span>
    <span class="dot r20d62 water"></span>
    <span class="dot r20d63 water"></span>
    <span class="dot r20d64 water"></span>
    <span class="dot r20d65 water"></span>
    <span class="dot r20d66 water"></span>
    <span class="dot r20d67 water"></span>
    <span class="dot r20d68 water"></span>
  </div>
  <div class="row r21">
    <span class="dot r21d1 water"></span>
    <span class="dot r21d2 water"></span>
    <span class="dot r21d3 water"></span>
    <span class="dot r21d4 water"></span>
    <span class="dot r21d5 water"></span>
    <span class="dot r21d6 water"></span>
    <span class="dot r21d7 water"></span>
    <span class="dot r21d8 water"></span>
    <span class="dot r21d9 water"></span>
    <span class="dot r21d10 water"></span>
    <span class="dot r21d11 water"></span>
    <span class="dot r21d12 water"></span>
    <span class="dot r21d13 north-america"></span>
    <span class="dot r21d14 north-america"></span>
    <span class="dot r21d15 north-america"></span>
    <span class="dot r21d16 north-america"></span>
    <span class="dot r21d17 water"></span>
    <span class="dot r21d18 north-america"></span>
    <span class="dot r21d19 north-america"></span>
    <span class="dot r21d20 water"></span>
    <span class="dot r21d21 water"></span>
    <span class="dot r21d22 water"></span>
    <span class="dot r21d23 water"></span>
    <span class="dot r21d24 water"></span>
    <span class="dot r21d25 water"></span>
    <span class="dot r21d26 water"></span>
    <span class="dot r21d27 water"></span>
    <span class="dot r21d28 water"></span>
    <span class="dot r21d29 africa"></span>
    <span class="dot r21d30 africa"></span>
    <span class="dot r21d31 africa"></span>
    <span class="dot r21d32 africa"></span>
    <span class="dot r21d33 africa"></span>
    <span class="dot r21d34 africa"></span>
    <span class="dot r21d35 africa"></span>
    <span class="dot r21d36 africa"></span>
    <span class="dot r21d37 africa"></span>
    <span class="dot r21d38 africa"></span>
    <span class="dot r21d39 africa"></span>
    <span class="dot r21d40 water"></span>
    <span class="dot r21d41 asia"></span>
    <span class="dot r21d42 asia"></span>
    <span class="dot r21d43 asia"></span>
    <span class="dot r21d44 water"></span>
    <span class="dot r21d45 water"></span>
    <span class="dot r21d46 asia"></span>
    <span class="dot r21d47 asia"></span>
    <span class="dot r21d48 asia"></span>
    <span class="dot r21d49 water"></span>
    <span class="dot r21d50 asia"></span>
    <span class="dot r21d51 asia"></span>
    <span class="dot r21d52 asia"></span>
    <span class="dot r21d53 water"></span>
    <span class="dot r21d54 water"></span>
    <span class="dot r21d55 asia"></span>
    <span class="dot r21d56 water"></span>
    <span class="dot r21d57 water"></span>
    <span class="dot r21d58 water"></span>
    <span class="dot r21d59 water"></span>
    <span class="dot r21d60 water"></span>
    <span class="dot r21d61 water"></span>
    <span class="dot r21d62 water"></span>
    <span class="dot r21d63 water"></span>
    <span class="dot r21d64 water"></span>
    <span class="dot r21d65 water"></span>
    <span class="dot r21d66 water"></span>
    <span class="dot r21d67 water"></span>
    <span class="dot r21d68 water"></span>
  </div>
  <div class="row r22">
    <span class="dot r22d1 water"></span>
    <span class="dot r22d2 water"></span>
    <span class="dot r22d3 water"></span>
    <span class="dot r22d4 water"></span>
    <span class="dot r22d5 water"></span>
    <span class="dot r22d6 water"></span>
    <span class="dot r22d7 water"></span>
    <span class="dot r22d8 water"></span>
    <span class="dot r22d9 water"></span>
    <span class="dot r22d10 water"></span>
    <span class="dot r22d11 water"></span>
    <span class="dot r22d12 water"></span>
    <span class="dot r22d13 water"></span>
    <span class="dot r22d14 water"></span>
    <span class="dot r22d15 water"></span>
    <span class="dot r22d16 north-america"></span>
    <span class="dot r22d17 north-america"></span>
    <span class="dot r22d18 water"></span>
    <span class="dot r22d19 water"></span>
    <span class="dot r22d20 south-america"></span>
    <span class="dot r22d21 south-america"></span>
    <span class="dot r22d22 water"></span>
    <span class="dot r22d23 water"></span>
    <span class="dot r22d24 water"></span>
    <span class="dot r22d25 water"></span>
    <span class="dot r22d26 water"></span>
    <span class="dot r22d27 water"></span>
    <span class="dot r22d28 water"></span>
    <span class="dot r22d29 africa"></span>
    <span class="dot r22d30 africa"></span>
    <span class="dot r22d31 africa"></span>
    <span class="dot r22d32 africa"></span>
    <span class="dot r22d33 africa"></span>
    <span class="dot r22d34 africa"></span>
    <span class="dot r22d35 africa"></span>
    <span class="dot r22d36 africa"></span>
    <span class="dot r22d37 africa"></span>
    <span class="dot r22d38 africa"></span>
    <span class="dot r22d39 africa"></span>
    <span class="dot r22d40 africa"></span>
    <span class="dot r22d41 water"></span>
    <span class="dot r22d42 water"></span>
    <span class="dot r22d43 water"></span>
    <span class="dot r22d44 water"></span>
    <span class="dot r22d45 water"></span>
    <span class="dot r22d46 water"></span>
    <span class="dot r22d47 asia"></span>
    <span class="dot r22d48 water"></span>
    <span class="dot r22d49 water"></span>
    <span class="dot r22d50 water"></span>
    <span class="dot r22d51 asia"></span>
    <span class="dot r22d52 asia"></span>
    <span class="dot r22d53 asia"></span>
    <span class="dot r22d54 water"></span>
    <span class="dot r22d55 asia"></span>
    <span class="dot r22d56 asia"></span>
    <span class="dot r22d57 water"></span>
    <span class="dot r22d58 water"></span>
    <span class="dot r22d59 water"></span>
    <span class="dot r22d60 water"></span>
    <span class="dot r22d61 water"></span>
    <span class="dot r22d62 water"></span>
    <span class="dot r22d63 water"></span>
    <span class="dot r22d64 water"></span>
    <span class="dot r22d65 water"></span>
    <span class="dot r22d66 water"></span>
    <span class="dot r22d67 water"></span>
    <span class="dot r22d68 water"></span>
  </div>
  <div class="row r23">
    <span class="dot r23d1 water"></span>
    <span class="dot r23d2 water"></span>
    <span class="dot r23d3 water"></span>
    <span class="dot r23d4 water"></span>
    <span class="dot r23d5 water"></span>
    <span class="dot r23d6 water"></span>
    <span class="dot r23d7 water"></span>
    <span class="dot r23d8 water"></span>
    <span class="dot r23d9 water"></span>
    <span class="dot r23d10 water"></span>
    <span class="dot r23d11 water"></span>
    <span class="dot r23d12 water"></span>
    <span class="dot r23d13 water"></span>
    <span class="dot r23d14 water"></span>
    <span class="dot r23d15 water"></span>
    <span class="dot r23d16 water"></span>
    <span class="dot r23d17 north-america"></span>
    <span class="dot r23d18 south-america"></span>
    <span class="dot r23d19 south-america"></span>
    <span class="dot r23d20 south-america"></span>
    <span class="dot r23d21 south-america"></span>
    <span class="dot r23d22 south-america"></span>
    <span class="dot r23d23 water"></span>
    <span class="dot r23d24 water"></span>
    <span class="dot r23d25 water"></span>
    <span class="dot r23d26 water"></span>
    <span class="dot r23d27 water"></span>
    <span class="dot r23d28 water"></span>
    <span class="dot r23d29 water"></span>
    <span class="dot r23d30 africa"></span>
    <span class="dot r23d31 africa"></span>
    <span class="dot r23d32 africa"></span>
    <span class="dot r23d33 africa"></span>
    <span class="dot r23d34 africa"></span>
    <span class="dot r23d35 africa"></span>
    <span class="dot r23d36 africa"></span>
    <span class="dot r23d37 africa"></span>
    <span class="dot r23d38 africa"></span>
    <span class="dot r23d39 africa"></span>
    <span class="dot r23d40 africa"></span>
    <span class="dot r23d41 africa"></span>
    <span class="dot r23d42 africa"></span>
    <span class="dot r23d43 water"></span>
    <span class="dot r23d44 water"></span>
    <span class="dot r23d45 water"></span>
    <span class="dot r23d46 water"></span>
    <span class="dot r23d47 asia"></span>
    <span class="dot r23d48 water"></span>
    <span class="dot r23d49 water"></span>
    <span class="dot r23d50 water"></span>
    <span class="dot r23d51 water"></span>
    <span class="dot r23d52 asia"></span>
    <span class="dot r23d53 water"></span>
    <span class="dot r23d54 water"></span>
    <span class="dot r23d55 asia"></span>
    <span class="dot r23d56 asia"></span>
    <span class="dot r23d57 water"></span>
    <span class="dot r23d58 water"></span>
    <span class="dot r23d59 water"></span>
    <span class="dot r23d60 water"></span>
    <span class="dot r23d61 water"></span>
    <span class="dot r23d62 water"></span>
    <span class="dot r23d63 water"></span>
    <span class="dot r23d64 water"></span>
    <span class="dot r23d65 water"></span>
    <span class="dot r23d66 water"></span>
    <span class="dot r23d67 water"></span>
    <span class="dot r23d68 water"></span>
  </div>
  <div class="row r24">
    <span class="dot r24d1 water"></span>
    <span class="dot r24d2 water"></span>
    <span class="dot r24d3 water"></span>
    <span class="dot r24d4 water"></span>
    <span class="dot r24d5 water"></span>
    <span class="dot r24d6 water"></span>
    <span class="dot r24d7 water"></span>
    <span class="dot r24d8 water"></span>
    <span class="dot r24d9 water"></span>
    <span class="dot r24d10 water"></span>
    <span class="dot r24d11 water"></span>
    <span class="dot r24d12 water"></span>
    <span class="dot r24d13 water"></span>
    <span class="dot r24d14 water"></span>
    <span class="dot r24d15 water"></span>
    <span class="dot r24d16 water"></span>
    <span class="dot r24d17 south-america"></span>
    <span class="dot r24d18 south-america"></span>
    <span class="dot r24d19 south-america"></span>
    <span class="dot r24d20 south-america"></span>
    <span class="dot r24d21 south-america"></span>
    <span class="dot r24d22 south-america"></span>
    <span class="dot r24d23 south-america"></span>
    <span class="dot r24d24 water"></span>
    <span class="dot r24d25 water"></span>
    <span class="dot r24d26 water"></span>
    <span class="dot r24d27 water"></span>
    <span class="dot r24d28 water"></span>
    <span class="dot r24d29 water"></span>
    <span class="dot r24d30 water"></span>
    <span class="dot r24d31 africa"></span>
    <span class="dot r24d32 africa"></span>
    <span class="dot r24d33 africa"></span>
    <span class="dot r24d34 africa"></span>
    <span class="dot r24d35 africa"></span>
    <span class="dot r24d36 africa"></span>
    <span class="dot r24d37 africa"></span>
    <span class="dot r24d38 africa"></span>
    <span class="dot r24d39 africa"></span>
    <span class="dot r24d40 africa"></span>
    <span class="dot r24d41 africa"></span>
    <span class="dot r24d42 water"></span>
    <span class="dot r24d43 water"></span>
    <span class="dot r24d44 water"></span>
    <span class="dot r24d45 water"></span>
    <span class="dot r24d46 water"></span>
    <span class="dot r24d47 water"></span>
    <span class="dot r24d48 asia"></span>
    <span class="dot r24d49 water"></span>
    <span class="dot r24d50 water"></span>
    <span class="dot r24d51 asia"></span>
    <span class="dot r24d52 water"></span>
    <span class="dot r24d53 water"></span>
    <span class="dot r24d54 asia"></span>
    <span class="dot r24d55 water"></span>
    <span class="dot r24d56 asia"></span>
    <span class="dot r24d57 water"></span>
    <span class="dot r24d58 water"></span>
    <span class="dot r24d59 water"></span>
    <span class="dot r24d60 water"></span>
    <span class="dot r24d61 water"></span>
    <span class="dot r24d62 water"></span>
    <span class="dot r24d63 water"></span>
    <span class="dot r24d64 water"></span>
    <span class="dot r24d65 water"></span>
    <span class="dot r24d66 water"></span>
    <span class="dot r24d67 water"></span>
    <span class="dot r24d68 water"></span>
  </div>
  <div class="row r25">
    <span class="dot r25d1 water"></span>
    <span class="dot r25d2 water"></span>
    <span class="dot r25d3 water"></span>
    <span class="dot r25d4 water"></span>
    <span class="dot r25d5 water"></span>
    <span class="dot r25d6 water"></span>
    <span class="dot r25d7 water"></span>
    <span class="dot r25d8 water"></span>
    <span class="dot r25d9 water"></span>
    <span class="dot r25d10 water"></span>
    <span class="dot r25d11 water"></span>
    <span class="dot r25d12 water"></span>
    <span class="dot r25d13 water"></span>
    <span class="dot r25d14 water"></span>
    <span class="dot r25d15 water"></span>
    <span class="dot r25d16 water"></span>
    <span class="dot r25d17 south-america"></span>
    <span class="dot r25d18 south-america"></span>
    <span class="dot r25d19 south-america"></span>
    <span class="dot r25d20 south-america"></span>
    <span class="dot r25d21 south-america"></span>
    <span class="dot r25d22 south-america"></span>
    <span class="dot r25d23 south-america"></span>
    <span class="dot r25d24 south-america"></span>
    <span class="dot r25d25 water"></span>
    <span class="dot r25d26 water"></span>
    <span class="dot r25d27 water"></span>
    <span class="dot r25d28 water"></span>
    <span class="dot r25d29 water"></span>
    <span class="dot r25d30 water"></span>
    <span class="dot r25d31 water"></span>
    <span class="dot r25d32 water"></span>
    <span class="dot r25d33 water"></span>
    <span class="dot r25d34 africa"></span>
    <span class="dot r25d35 africa"></span>
    <span class="dot r25d36 africa"></span>
    <span class="dot r25d37 africa"></span>
    <span class="dot r25d38 africa"></span>
    <span class="dot r25d39 africa"></span>
    <span class="dot r25d40 africa"></span>
    <span class="dot r25d41 water"></span>
    <span class="dot r25d42 water"></span>
    <span class="dot r25d43 water"></span>
    <span class="dot r25d44 water"></span>
    <span class="dot r25d45 water"></span>
    <span class="dot r25d46 water"></span>
    <span class="dot r25d47 water"></span>
    <span class="dot r25d48 water"></span>
    <span class="dot r25d49 water"></span>
    <span class="dot r25d50 water"></span>
    <span class="dot r25d51 asia"></span>
    <span class="dot r25d52 asia"></span>
    <span class="dot r25d53 asia"></span>
    <span class="dot r25d54 asia"></span>
    <span class="dot r25d55 asia"></span>
    <span class="dot r25d56 asia"></span>
    <span class="dot r25d57 asia"></span>
    <span class="dot r25d58 asia"></span>
    <span class="dot r25d59 water"></span>
    <span class="dot r25d60 water"></span>
    <span class="dot r25d61 water"></span>
    <span class="dot r25d62 water"></span>
    <span class="dot r25d63 water"></span>
    <span class="dot r25d64 water"></span>
    <span class="dot r25d65 water"></span>
    <span class="dot r25d66 water"></span>
    <span class="dot r25d67 water"></span>
    <span class="dot r25d68 water"></span>
  </div>
  <div class="row r26">
    <span class="dot r26d1 water"></span>
    <span class="dot r26d2 water"></span>
    <span class="dot r26d3 water"></span>
    <span class="dot r26d4 water"></span>
    <span class="dot r26d5 water"></span>
    <span class="dot r26d6 water"></span>
    <span class="dot r26d7 water"></span>
    <span class="dot r26d8 water"></span>
    <span class="dot r26d9 water"></span>
    <span class="dot r26d10 water"></span>
    <span class="dot r26d11 water"></span>
    <span class="dot r26d12 water"></span>
    <span class="dot r26d13 water"></span>
    <span class="dot r26d14 water"></span>
    <span class="dot r26d15 water"></span>
    <span class="dot r26d16 water"></span>
    <span class="dot r26d17 south-america"></span>
    <span class="dot r26d18 south-america"></span>
    <span class="dot r26d19 south-america"></span>
    <span class="dot r26d20 south-america"></span>
    <span class="dot r26d21 south-america"></span>
    <span class="dot r26d22 south-america"></span>
    <span class="dot r26d23 south-america"></span>
    <span class="dot r26d24 south-america"></span>
    <span class="dot r26d25 south-america"></span>
    <span class="dot r26d26 south-america"></span>
    <span class="dot r26d27 water"></span>
    <span class="dot r26d28 water"></span>
    <span class="dot r26d29 water"></span>
    <span class="dot r26d30 water"></span>
    <span class="dot r26d31 water"></span>
    <span class="dot r26d32 water"></span>
    <span class="dot r26d33 water"></span>
    <span class="dot r26d34 water"></span>
    <span class="dot r26d35 africa"></span>
    <span class="dot r26d36 africa"></span>
    <span class="dot r26d37 africa"></span>
    <span class="dot r26d38 africa"></span>
    <span class="dot r26d39 africa"></span>
    <span class="dot r26d40 africa"></span>
    <span class="dot r26d41 water"></span>
    <span class="dot r26d42 water"></span>
    <span class="dot r26d43 water"></span>
    <span class="dot r26d44 water"></span>
    <span class="dot r26d45 water"></span>
    <span class="dot r26d46 water"></span>
    <span class="dot r26d47 water"></span>
    <span class="dot r26d48 water"></span>
    <span class="dot r26d49 water"></span>
    <span class="dot r26d50 water"></span>
    <span class="dot r26d51 water"></span>
    <span class="dot r26d52 asia"></span>
    <span class="dot r26d53 asia"></span>
    <span class="dot r26d54 water"></span>
    <span class="dot r26d55 asia"></span>
    <span class="dot r26d56 water"></span>
    <span class="dot r26d57 water"></span>
    <span class="dot r26d58 australia"></span>
    <span class="dot r26d59 australia"></span>
    <span class="dot r26d60 australia"></span>
    <span class="dot r26d61 australia"></span>
    <span class="dot r26d62 australia"></span>
    <span class="dot r26d63 water"></span>
    <span class="dot r26d64 water"></span>
    <span class="dot r26d65 water"></span>
    <span class="dot r26d66 water"></span>
    <span class="dot r26d67 water"></span>
    <span class="dot r26d68 water"></span>
  </div>
  <div class="row r27">
    <span class="dot r27d1 water"></span>
    <span class="dot r27d2 water"></span>
    <span class="dot r27d3 water"></span>
    <span class="dot r27d4 water"></span>
    <span class="dot r27d5 water"></span>
    <span class="dot r27d6 water"></span>
    <span class="dot r27d7 water"></span>
    <span class="dot r27d8 water"></span>
    <span class="dot r27d9 water"></span>
    <span class="dot r27d10 water"></span>
    <span class="dot r27d11 water"></span>
    <span class="dot r27d12 water"></span>
    <span class="dot r27d13 water"></span>
    <span class="dot r27d14 water"></span>
    <span class="dot r27d15 water"></span>
    <span class="dot r27d16 water"></span>
    <span class="dot r27d17 water"></span>
    <span class="dot r27d18 south-america"></span>
    <span class="dot r27d19 south-america"></span>
    <span class="dot r27d20 south-america"></span>
    <span class="dot r27d21 south-america"></span>
    <span class="dot r27d22 south-america"></span>
    <span class="dot r27d23 south-america"></span>
    <span class="dot r27d24 south-america"></span>
    <span class="dot r27d25 south-america"></span>
    <span class="dot r27d26 south-america"></span>
    <span class="dot r27d27 water"></span>
    <span class="dot r27d28 water"></span>
    <span class="dot r27d29 water"></span>
    <span class="dot r27d30 water"></span>
    <span class="dot r27d31 water"></span>
    <span class="dot r27d32 water"></span>
    <span class="dot r27d33 water"></span>
    <span class="dot r27d34 water"></span>
    <span class="dot r27d35 africa"></span>
    <span class="dot r27d36 africa"></span>
    <span class="dot r27d37 africa"></span>
    <span class="dot r27d38 africa"></span>
    <span class="dot r27d39 africa"></span>
    <span class="dot r27d40 africa"></span>
    <span class="dot r27d41 water"></span>
    <span class="dot r27d42 water"></span>
    <span class="dot r27d43 water"></span>
    <span class="dot r27d44 water"></span>
    <span class="dot r27d45 water"></span>
    <span class="dot r27d46 water"></span>
    <span class="dot r27d47 water"></span>
    <span class="dot r27d48 water"></span>
    <span class="dot r27d49 water"></span>
    <span class="dot r27d50 water"></span>
    <span class="dot r27d51 water"></span>
    <span class="dot r27d52 water"></span>
    <span class="dot r27d53 water"></span>
    <span class="dot r27d54 asia"></span>
    <span class="dot r27d55 water"></span>
    <span class="dot r27d56 water"></span>
    <span class="dot r27d57 australia"></span>
    <span class="dot r27d58 water"></span>
    <span class="dot r27d59 australia"></span>
    <span class="dot r27d60 australia"></span>
    <span class="dot r27d61 water"></span>
    <span class="dot r27d62 water"></span>
    <span class="dot r27d63 australia"></span>
    <span class="dot r27d64 water"></span>
    <span class="dot r27d65 water"></span>
    <span class="dot r27d66 water"></span>
    <span class="dot r27d67 water"></span>
    <span class="dot r27d68 water"></span>
  </div>
  <div class="row r28">
    <span class="dot r28d1 water"></span>
    <span class="dot r28d2 water"></span>
    <span class="dot r28d3 water"></span>
    <span class="dot r28d4 water"></span>
    <span class="dot r28d5 water"></span>
    <span class="dot r28d6 water"></span>
    <span class="dot r28d7 water"></span>
    <span class="dot r28d8 water"></span>
    <span class="dot r28d9 water"></span>
    <span class="dot r28d10 water"></span>
    <span class="dot r28d11 water"></span>
    <span class="dot r28d12 water"></span>
    <span class="dot r28d13 water"></span>
    <span class="dot r28d14 water"></span>
    <span class="dot r28d15 water"></span>
    <span class="dot r28d16 water"></span>
    <span class="dot r28d17 water"></span>
    <span class="dot r28d18 south-america"></span>
    <span class="dot r28d19 south-america"></span>
    <span class="dot r28d20 south-america"></span>
    <span class="dot r28d21 south-america"></span>
    <span class="dot r28d22 south-america"></span>
    <span class="dot r28d23 south-america"></span>
    <span class="dot r28d24 south-america"></span>
    <span class="dot r28d25 south-america"></span>
    <span class="dot r28d26 water"></span>
    <span class="dot r28d27 water"></span>
    <span class="dot r28d28 water"></span>
    <span class="dot r28d29 water"></span>
    <span class="dot r28d30 water"></span>
    <span class="dot r28d31 water"></span>
    <span class="dot r28d32 water"></span>
    <span class="dot r28d33 water"></span>
    <span class="dot r28d34 water"></span>
    <span class="dot r28d35 africa"></span>
    <span class="dot r28d36 africa"></span>
    <span class="dot r28d37 africa"></span>
    <span class="dot r28d38 africa"></span>
    <span class="dot r28d39 africa"></span>
    <span class="dot r28d40 africa"></span>
    <span class="dot r28d41 africa"></span>
    <span class="dot r28d42 water"></span>
    <span class="dot r28d43 water"></span>
    <span class="dot r28d44 water"></span>
    <span class="dot r28d45 water"></span>
    <span class="dot r28d46 water"></span>
    <span class="dot r28d47 water"></span>
    <span class="dot r28d48 water"></span>
    <span class="dot r28d49 water"></span>
    <span class="dot r28d50 water"></span>
    <span class="dot r28d51 water"></span>
    <span class="dot r28d52 water"></span>
    <span class="dot r28d53 water"></span>
    <span class="dot r28d54 water"></span>
    <span class="dot r28d55 water"></span>
    <span class="dot r28d56 australia"></span>
    <span class="dot r28d57 australia"></span>
    <span class="dot r28d58 australia"></span>
    <span class="dot r28d59 australia"></span>
    <span class="dot r28d60 water"></span>
    <span class="dot r28d61 water"></span>
    <span class="dot r28d62 water"></span>
    <span class="dot r28d63 water"></span>
    <span class="dot r28d64 water"></span>
    <span class="dot r28d65 water"></span>
    <span class="dot r28d66 water"></span>
    <span class="dot r28d67 water"></span>
    <span class="dot r28d68 water"></span>
  </div>
  <div class="row r29">
    <span class="dot r29d1 water"></span>
    <span class="dot r29d2 water"></span>
    <span class="dot r29d3 water"></span>
    <span class="dot r29d4 water"></span>
    <span class="dot r29d5 water"></span>
    <span class="dot r29d6 water"></span>
    <span class="dot r29d7 water"></span>
    <span class="dot r29d8 water"></span>
    <span class="dot r29d9 water"></span>
    <span class="dot r29d10 water"></span>
    <span class="dot r29d11 water"></span>
    <span class="dot r29d12 water"></span>
    <span class="dot r29d13 water"></span>
    <span class="dot r29d14 water"></span>
    <span class="dot r29d15 water"></span>
    <span class="dot r29d16 water"></span>
    <span class="dot r29d17 water"></span>
    <span class="dot r29d18 water"></span>
    <span class="dot r29d19 south-america"></span>
    <span class="dot r29d20 south-america"></span>
    <span class="dot r29d21 south-america"></span>
    <span class="dot r29d22 south-america"></span>
    <span class="dot r29d23 south-america"></span>
    <span class="dot r29d24 south-america"></span>
    <span class="dot r29d25 south-america"></span>
    <span class="dot r29d26 water"></span>
    <span class="dot r29d27 water"></span>
    <span class="dot r29d28 water"></span>
    <span class="dot r29d29 water"></span>
    <span class="dot r29d30 water"></span>
    <span class="dot r29d31 water"></span>
    <span class="dot r29d32 water"></span>
    <span class="dot r29d33 water"></span>
    <span class="dot r29d34 water"></span>
    <span class="dot r29d35 africa"></span>
    <span class="dot r29d36 africa"></span>
    <span class="dot r29d37 africa"></span>
    <span class="dot r29d38 africa"></span>
    <span class="dot r29d39 africa"></span>
    <span class="dot r29d40 water"></span>
    <span class="dot r29d41 africa"></span>
    <span class="dot r29d42 water"></span>
    <span class="dot r29d43 water"></span>
    <span class="dot r29d44 water"></span>
    <span class="dot r29d45 water"></span>
    <span class="dot r29d46 water"></span>
    <span class="dot r29d47 water"></span>
    <span class="dot r29d48 water"></span>
    <span class="dot r29d49 water"></span>
    <span class="dot r29d50 water"></span>
    <span class="dot r29d51 water"></span>
    <span class="dot r29d52 water"></span>
    <span class="dot r29d53 water"></span>
    <span class="dot r29d54 water"></span>
    <span class="dot r29d55 australia"></span>
    <span class="dot r29d56 australia"></span>
    <span class="dot r29d57 australia"></span>
    <span class="dot r29d58 australia"></span>
    <span class="dot r29d59 australia"></span>
    <span class="dot r29d60 australia"></span>
    <span class="dot r29d61 water"></span>
    <span class="dot r29d62 water"></span>
    <span class="dot r29d63 water"></span>
    <span class="dot r29d64 water"></span>
    <span class="dot r29d65 water"></span>
    <span class="dot r29d66 water"></span>
    <span class="dot r29d67 water"></span>
    <span class="dot r29d68 water"></span>
  </div>
  <div class="row r30">
    <span class="dot r30d1 water"></span>
    <span class="dot r30d2 water"></span>
    <span class="dot r30d3 water"></span>
    <span class="dot r30d4 water"></span>
    <span class="dot r30d5 water"></span>
    <span class="dot r30d6 water"></span>
    <span class="dot r30d7 water"></span>
    <span class="dot r30d8 water"></span>
    <span class="dot r30d9 water"></span>
    <span class="dot r30d10 water"></span>
    <span class="dot r30d11 water"></span>
    <span class="dot r30d12 water"></span>
    <span class="dot r30d13 water"></span>
    <span class="dot r30d14 water"></span>
    <span class="dot r30d15 water"></span>
    <span class="dot r30d16 water"></span>
    <span class="dot r30d17 water"></span>
    <span class="dot r30d18 water"></span>
    <span class="dot r30d19 south-america"></span>
    <span class="dot r30d20 south-america"></span>
    <span class="dot r30d21 south-america"></span>
    <span class="dot r30d22 south-america"></span>
    <span class="dot r30d23 south-america"></span>
    <span class="dot r30d24 south-america"></span>
    <span class="dot r30d25 water"></span>
    <span class="dot r30d26 water"></span>
    <span class="dot r30d27 water"></span>
    <span class="dot r30d28 water"></span>
    <span class="dot r30d29 water"></span>
    <span class="dot r30d30 water"></span>
    <span class="dot r30d31 water"></span>
    <span class="dot r30d32 water"></span>
    <span class="dot r30d33 water"></span>
    <span class="dot r30d34 water"></span>
    <span class="dot r30d35 africa"></span>
    <span class="dot r30d36 africa"></span>
    <span class="dot r30d37 africa"></span>
    <span class="dot r30d38 africa"></span>
    <span class="dot r30d39 africa"></span>
    <span class="dot r30d40 water"></span>
    <span class="dot r30d41 africa"></span>
    <span class="dot r30d42 water"></span>
    <span class="dot r30d43 water"></span>
    <span class="dot r30d44 water"></span>
    <span class="dot r30d45 water"></span>
    <span class="dot r30d46 water"></span>
    <span class="dot r30d47 water"></span>
    <span class="dot r30d48 water"></span>
    <span class="dot r30d49 water"></span>
    <span class="dot r30d50 water"></span>
    <span class="dot r30d51 water"></span>
    <span class="dot r30d52 water"></span>
    <span class="dot r30d53 water"></span>
    <span class="dot r30d54 australia"></span>
    <span class="dot r30d55 australia"></span>
    <span class="dot r30d56 australia"></span>
    <span class="dot r30d57 australia"></span>
    <span class="dot r30d58 australia"></span>
    <span class="dot r30d59 australia"></span>
    <span class="dot r30d60 australia"></span>
    <span class="dot r30d61 australia"></span>
    <span class="dot r30d62 water"></span>
    <span class="dot r30d63 water"></span>
    <span class="dot r30d64 water"></span>
    <span class="dot r30d65 water"></span>
    <span class="dot r30d66 water"></span>
    <span class="dot r30d67 water"></span>
    <span class="dot r30d68 water"></span>
  </div>
  <div class="row r31">
    <span class="dot r31d1 water"></span>
    <span class="dot r31d2 water"></span>
    <span class="dot r31d3 water"></span>
    <span class="dot r31d4 water"></span>
    <span class="dot r31d5 water"></span>
    <span class="dot r31d6 water"></span>
    <span class="dot r31d7 water"></span>
    <span class="dot r31d8 water"></span>
    <span class="dot r31d9 water"></span>
    <span class="dot r31d10 water"></span>
    <span class="dot r31d11 water"></span>
    <span class="dot r31d12 water"></span>
    <span class="dot r31d13 water"></span>
    <span class="dot r31d14 water"></span>
    <span class="dot r31d15 water"></span>
    <span class="dot r31d16 water"></span>
    <span class="dot r31d17 water"></span>
    <span class="dot r31d18 water"></span>
    <span class="dot r31d19 south-america"></span>
    <span class="dot r31d20 south-america"></span>
    <span class="dot r31d21 south-america"></span>
    <span class="dot r31d22 south-america"></span>
    <span class="dot r31d23 south-america"></span>
    <span class="dot r31d24 water"></span>
    <span class="dot r31d25 water"></span>
    <span class="dot r31d26 water"></span>
    <span class="dot r31d27 water"></span>
    <span class="dot r31d28 water"></span>
    <span class="dot r31d29 water"></span>
    <span class="dot r31d30 water"></span>
    <span class="dot r31d31 water"></span>
    <span class="dot r31d32 water"></span>
    <span class="dot r31d33 water"></span>
    <span class="dot r31d34 water"></span>
    <span class="dot r31d35 water"></span>
    <span class="dot r31d36 africa"></span>
    <span class="dot r31d37 africa"></span>
    <span class="dot r31d38 africa"></span>
    <span class="dot r31d39 water"></span>
    <span class="dot r31d40 water"></span>
    <span class="dot r31d41 water"></span>
    <span class="dot r31d42 water"></span>
    <span class="dot r31d43 water"></span>
    <span class="dot r31d44 water"></span>
    <span class="dot r31d45 water"></span>
    <span class="dot r31d46 water"></span>
    <span class="dot r31d47 water"></span>
    <span class="dot r31d48 water"></span>
    <span class="dot r31d49 water"></span>
    <span class="dot r31d50 water"></span>
    <span class="dot r31d51 water"></span>
    <span class="dot r31d52 water"></span>
    <span class="dot r31d53 water"></span>
    <span class="dot r31d54 australia"></span>
    <span class="dot r31d55 australia"></span>
    <span class="dot r31d56 australia"></span>
    <span class="dot r31d57 australia"></span>
    <span class="dot r31d58 australia"></span>
    <span class="dot r31d59 australia"></span>
    <span class="dot r31d60 australia"></span>
    <span class="dot r31d61 australia"></span>
    <span class="dot r31d62 water"></span>
    <span class="dot r31d63 water"></span>
    <span class="dot r31d64 water"></span>
    <span class="dot r31d65 water"></span>
    <span class="dot r31d66 water"></span>
    <span class="dot r31d67 water"></span>
    <span class="dot r31d68 water"></span>
  </div>
  <div class="row r32">
    <span class="dot r32d1 water"></span>
    <span class="dot r32d2 water"></span>
    <span class="dot r32d3 water"></span>
    <span class="dot r32d4 water"></span>
    <span class="dot r32d5 water"></span>
    <span class="dot r32d6 water"></span>
    <span class="dot r32d7 water"></span>
    <span class="dot r32d8 water"></span>
    <span class="dot r32d9 water"></span>
    <span class="dot r32d10 water"></span>
    <span class="dot r32d11 water"></span>
    <span class="dot r32d12 water"></span>
    <span class="dot r32d13 water"></span>
    <span class="dot r32d14 water"></span>
    <span class="dot r32d15 water"></span>
    <span class="dot r32d16 water"></span>
    <span class="dot r32d17 water"></span>
    <span class="dot r32d18 water"></span>
    <span class="dot r32d19 south-america"></span>
    <span class="dot r32d20 south-america"></span>
    <span class="dot r32d21 south-america"></span>
    <span class="dot r32d22 south-america"></span>
    <span class="dot r32d23 water"></span>
    <span class="dot r32d24 water"></span>
    <span class="dot r32d25 water"></span>
    <span class="dot r32d26 water"></span>
    <span class="dot r32d27 water"></span>
    <span class="dot r32d28 water"></span>
    <span class="dot r32d29 water"></span>
    <span class="dot r32d30 water"></span>
    <span class="dot r32d31 water"></span>
    <span class="dot r32d32 water"></span>
    <span class="dot r32d33 water"></span>
    <span class="dot r32d34 water"></span>
    <span class="dot r32d35 water"></span>
    <span class="dot r32d36 africa"></span>
    <span class="dot r32d37 africa"></span>
    <span class="dot r32d38 water"></span>
    <span class="dot r32d39 water"></span>
    <span class="dot r32d40 water"></span>
    <span class="dot r32d41 water"></span>
    <span class="dot r32d42 water"></span>
    <span class="dot r32d43 water"></span>
    <span class="dot r32d44 water"></span>
    <span class="dot r32d45 water"></span>
    <span class="dot r32d46 water"></span>
    <span class="dot r32d47 water"></span>
    <span class="dot r32d48 water"></span>
    <span class="dot r32d49 water"></span>
    <span class="dot r32d50 water"></span>
    <span class="dot r32d51 water"></span>
    <span class="dot r32d52 water"></span>
    <span class="dot r32d53 water"></span>
    <span class="dot r32d54 australia"></span>
    <span class="dot r32d55 australia"></span>
    <span class="dot r32d56 australia"></span>
    <span class="dot r32d57 australia"></span>
    <span class="dot r32d58 australia"></span>
    <span class="dot r32d59 australia"></span>
    <span class="dot r32d60 australia"></span>
    <span class="dot r32d61 australia"></span>
    <span class="dot r32d62 water"></span>
    <span class="dot r32d63 water"></span>
    <span class="dot r32d64 water"></span>
    <span class="dot r32d65 water"></span>
    <span class="dot r32d66 water"></span>
    <span class="dot r32d67 water"></span>
    <span class="dot r32d68 water"></span>
  </div>
  <div class="row r33">
    <span class="dot r33d1 water"></span>
    <span class="dot r33d2 water"></span>
    <span class="dot r33d3 water"></span>
    <span class="dot r33d4 water"></span>
    <span class="dot r33d5 water"></span>
    <span class="dot r33d6 water"></span>
    <span class="dot r33d7 water"></span>
    <span class="dot r33d8 water"></span>
    <span class="dot r33d9 water"></span>
    <span class="dot r33d10 water"></span>
    <span class="dot r33d11 water"></span>
    <span class="dot r33d12 water"></span>
    <span class="dot r33d13 water"></span>
    <span class="dot r33d14 water"></span>
    <span class="dot r33d15 water"></span>
    <span class="dot r33d16 water"></span>
    <span class="dot r33d17 water"></span>
    <span class="dot r33d18 water"></span>
    <span class="dot r33d19 south-america"></span>
    <span class="dot r33d20 south-america"></span>
    <span class="dot r33d21 south-america"></span>
    <span class="dot r33d22 water"></span>
    <span class="dot r33d23 water"></span>
    <span class="dot r33d24 water"></span>
    <span class="dot r33d25 water"></span>
    <span class="dot r33d26 water"></span>
    <span class="dot r33d27 water"></span>
    <span class="dot r33d28 water"></span>
    <span class="dot r33d29 water"></span>
    <span class="dot r33d30 water"></span>
    <span class="dot r33d31 water"></span>
    <span class="dot r33d32 water"></span>
    <span class="dot r33d33 water"></span>
    <span class="dot r33d34 water"></span>
    <span class="dot r33d35 water"></span>
    <span class="dot r33d36 water"></span>
    <span class="dot r33d37 water"></span>
    <span class="dot r33d38 water"></span>
    <span class="dot r33d39 water"></span>
    <span class="dot r33d40 water"></span>
    <span class="dot r33d41 water"></span>
    <span class="dot r33d42 water"></span>
    <span class="dot r33d43 water"></span>
    <span class="dot r33d44 water"></span>
    <span class="dot r33d45 water"></span>
    <span class="dot r33d46 water"></span>
    <span class="dot r33d47 water"></span>
    <span class="dot r33d48 water"></span>
    <span class="dot r33d49 water"></span>
    <span class="dot r33d50 water"></span>
    <span class="dot r33d51 water"></span>
    <span class="dot r33d52 water"></span>
    <span class="dot r33d53 water"></span>
    <span class="dot r33d54 water"></span>
    <span class="dot r33d55 water"></span>
    <span class="dot r33d56 water"></span>
    <span class="dot r33d57 water"></span>
    <span class="dot r33d58 water"></span>
    <span class="dot r33d59 australia"></span>
    <span class="dot r33d60 australia"></span>
    <span class="dot r33d61 australia"></span>
    <span class="dot r33d62 water"></span>
    <span class="dot r33d63 water"></span>
    <span class="dot r33d64 water"></span>
    <span class="dot r33d65 australia"></span>
    <span class="dot r33d66 australia"></span>
    <span class="dot r33d67 water"></span>
    <span class="dot r33d68 water"></span>
  </div>
  <div class="row r34">
    <span class="dot r34d1 water"></span>
    <span class="dot r34d2 water"></span>
    <span class="dot r34d3 water"></span>
    <span class="dot r34d4 water"></span>
    <span class="dot r34d5 water"></span>
    <span class="dot r34d6 water"></span>
    <span class="dot r34d7 water"></span>
    <span class="dot r34d8 water"></span>
    <span class="dot r34d9 water"></span>
    <span class="dot r34d10 water"></span>
    <span class="dot r34d11 water"></span>
    <span class="dot r34d12 water"></span>
    <span class="dot r34d13 water"></span>
    <span class="dot r34d14 water"></span>
    <span class="dot r34d15 water"></span>
    <span class="dot r34d16 water"></span>
    <span class="dot r34d17 water"></span>
    <span class="dot r34d18 water"></span>
    <span class="dot r34d19 south-america"></span>
    <span class="dot r34d20 south-america"></span>
    <span class="dot r34d21 water"></span>
    <span class="dot r34d22 water"></span>
    <span class="dot r34d23 water"></span>
    <span class="dot r34d24 water"></span>
    <span class="dot r34d25 water"></span>
    <span class="dot r34d26 water"></span>
    <span class="dot r34d27 water"></span>
    <span class="dot r34d28 water"></span>
    <span class="dot r34d29 water"></span>
    <span class="dot r34d30 water"></span>
    <span class="dot r34d31 water"></span>
    <span class="dot r34d32 water"></span>
    <span class="dot r34d33 water"></span>
    <span class="dot r34d34 water"></span>
    <span class="dot r34d35 water"></span>
    <span class="dot r34d36 water"></span>
    <span class="dot r34d37 water"></span>
    <span class="dot r34d38 water"></span>
    <span class="dot r34d39 water"></span>
    <span class="dot r34d40 water"></span>
    <span class="dot r34d41 water"></span>
    <span class="dot r34d42 water"></span>
    <span class="dot r34d43 water"></span>
    <span class="dot r34d44 water"></span>
    <span class="dot r34d45 water"></span>
    <span class="dot r34d46 water"></span>
    <span class="dot r34d47 water"></span>
    <span class="dot r34d48 water"></span>
    <span class="dot r34d49 water"></span>
    <span class="dot r34d50 water"></span>
    <span class="dot r34d51 water"></span>
    <span class="dot r34d52 water"></span>
    <span class="dot r34d53 water"></span>
    <span class="dot r34d54 water"></span>
    <span class="dot r34d55 water"></span>
    <span class="dot r34d56 water"></span>
    <span class="dot r34d57 water"></span>
    <span class="dot r34d58 water"></span>
    <span class="dot r34d59 water"></span>
    <span class="dot r34d60 water"></span>
    <span class="dot r34d61 water"></span>
    <span class="dot r34d62 water"></span>
    <span class="dot r34d63 water"></span>
    <span class="dot r34d64 water"></span>
    <span class="dot r34d65 australia"></span>
    <span class="dot r34d66 water"></span>
    <span class="dot r34d67 water"></span>
    <span class="dot r34d68 water"></span>
  </div>
  <div class="row r35">
    <span class="dot r35d1 water"></span>
    <span class="dot r35d2 water"></span>
    <span class="dot r35d3 water"></span>
    <span class="dot r35d4 water"></span>
    <span class="dot r35d5 water"></span>
    <span class="dot r35d6 water"></span>
    <span class="dot r35d7 water"></span>
    <span class="dot r35d8 water"></span>
    <span class="dot r35d9 water"></span>
    <span class="dot r35d10 water"></span>
    <span class="dot r35d11 water"></span>
    <span class="dot r35d12 water"></span>
    <span class="dot r35d13 water"></span>
    <span class="dot r35d14 water"></span>
    <span class="dot r35d15 water"></span>
    <span class="dot r35d16 water"></span>
    <span class="dot r35d17 water"></span>
    <span class="dot r35d18 water"></span>
    <span class="dot r35d19 south-america"></span>
    <span class="dot r35d20 south-america"></span>
    <span class="dot r35d21 water"></span>
    <span class="dot r35d22 water"></span>
    <span class="dot r35d23 water"></span>
    <span class="dot r35d24 water"></span>
    <span class="dot r35d25 water"></span>
    <span class="dot r35d26 water"></span>
    <span class="dot r35d27 water"></span>
    <span class="dot r35d28 water"></span>
    <span class="dot r35d29 water"></span>
    <span class="dot r35d30 water"></span>
    <span class="dot r35d31 water"></span>
    <span class="dot r35d32 water"></span>
    <span class="dot r35d33 water"></span>
    <span class="dot r35d34 water"></span>
    <span class="dot r35d35 water"></span>
    <span class="dot r35d36 water"></span>
    <span class="dot r35d37 water"></span>
    <span class="dot r35d38 water"></span>
    <span class="dot r35d39 water"></span>
    <span class="dot r35d40 water"></span>
    <span class="dot r35d41 water"></span>
    <span class="dot r35d42 water"></span>
    <span class="dot r35d43 water"></span>
    <span class="dot r35d44 water"></span>
    <span class="dot r35d45 water"></span>
    <span class="dot r35d46 water"></span>
    <span class="dot r35d47 water"></span>
    <span class="dot r35d48 water"></span>
    <span class="dot r35d49 water"></span>
    <span class="dot r35d50 water"></span>
    <span class="dot r35d51 water"></span>
    <span class="dot r35d52 water"></span>
    <span class="dot r35d53 water"></span>
    <span class="dot r35d54 water"></span>
    <span class="dot r35d55 water"></span>
    <span class="dot r35d56 water"></span>
    <span class="dot r35d57 water"></span>
    <span class="dot r35d58 water"></span>
    <span class="dot r35d59 water"></span>
    <span class="dot r35d60 australia"></span>
    <span class="dot r35d61 water"></span>
    <span class="dot r35d62 water"></span>
    <span class="dot r35d63 water"></span>
    <span class="dot r35d64 australia"></span>
    <span class="dot r35d65 water"></span>
    <span class="dot r35d66 water"></span>
    <span class="dot r35d67 water"></span>
    <span class="dot r35d68 water"></span>
  </div>
  <div class="row r36">
    <span class="dot r36d1 water"></span>
    <span class="dot r36d2 water"></span>
    <span class="dot r36d3 water"></span>
    <span class="dot r36d4 water"></span>
    <span class="dot r36d5 water"></span>
    <span class="dot r36d6 water"></span>
    <span class="dot r36d7 water"></span>
    <span class="dot r36d8 water"></span>
    <span class="dot r36d9 water"></span>
    <span class="dot r36d10 water"></span>
    <span class="dot r36d11 water"></span>
    <span class="dot r36d12 water"></span>
    <span class="dot r36d13 water"></span>
    <span class="dot r36d14 water"></span>
    <span class="dot r36d15 water"></span>
    <span class="dot r36d16 water"></span>
    <span class="dot r36d17 water"></span>
    <span class="dot r36d18 water"></span>
    <span class="dot r36d19 south-america"></span>
    <span class="dot r36d20 south-america"></span>
    <span class="dot r36d21 water"></span>
    <span class="dot r36d22 water"></span>
    <span class="dot r36d23 water"></span>
    <span class="dot r36d24 water"></span>
    <span class="dot r36d25 water"></span>
    <span class="dot r36d26 water"></span>
    <span class="dot r36d27 water"></span>
    <span class="dot r36d28 water"></span>
    <span class="dot r36d29 water"></span>
    <span class="dot r36d30 water"></span>
    <span class="dot r36d31 water"></span>
    <span class="dot r36d32 water"></span>
    <span class="dot r36d33 water"></span>
    <span class="dot r36d34 water"></span>
    <span class="dot r36d35 water"></span>
    <span class="dot r36d36 water"></span>
    <span class="dot r36d37 water"></span>
    <span class="dot r36d38 water"></span>
    <span class="dot r36d39 water"></span>
    <span class="dot r36d40 water"></span>
    <span class="dot r36d41 water"></span>
    <span class="dot r36d42 water"></span>
    <span class="dot r36d43 water"></span>
    <span class="dot r36d44 water"></span>
    <span class="dot r36d45 water"></span>
    <span class="dot r36d46 water"></span>
    <span class="dot r36d47 water"></span>
    <span class="dot r36d48 water"></span>
    <span class="dot r36d49 water"></span>
    <span class="dot r36d50 water"></span>
    <span class="dot r36d51 water"></span>
    <span class="dot r36d52 water"></span>
    <span class="dot r36d53 water"></span>
    <span class="dot r36d54 water"></span>
    <span class="dot r36d55 water"></span>
    <span class="dot r36d56 water"></span>
    <span class="dot r36d57 water"></span>
    <span class="dot r36d58 water"></span>
    <span class="dot r36d59 water"></span>
    <span class="dot r36d60 water"></span>
    <span class="dot r36d61 water"></span>
    <span class="dot r36d62 water"></span>
    <span class="dot r36d63 water"></span>
    <span class="dot r36d64 water"></span>
    <span class="dot r36d65 water"></span>
    <span class="dot r36d66 water"></span>
    <span class="dot r36d67 water"></span>
    <span class="dot r36d68 water"></span>
  </div>
  <div class="row r37">
    <span class="dot r37d1 water"></span>
    <span class="dot r37d2 water"></span>
    <span class="dot r37d3 water"></span>
    <span class="dot r37d4 water"></span>
    <span class="dot r37d5 water"></span>
    <span class="dot r37d6 water"></span>
    <span class="dot r37d7 water"></span>
    <span class="dot r37d8 water"></span>
    <span class="dot r37d9 water"></span>
    <span class="dot r37d10 water"></span>
    <span class="dot r37d11 water"></span>
    <span class="dot r37d12 water"></span>
    <span class="dot r37d13 water"></span>
    <span class="dot r37d14 water"></span>
    <span class="dot r37d15 water"></span>
    <span class="dot r37d16 water"></span>
    <span class="dot r37d17 water"></span>
    <span class="dot r37d18 water"></span>
    <span class="dot r37d19 south-america"></span>
    <span class="dot r37d20 south-america"></span>
    <span class="dot r37d21 south-america"></span>
    <span class="dot r37d22 water"></span>
    <span class="dot r37d23 water"></span>
    <span class="dot r37d24 water"></span>
    <span class="dot r37d25 water"></span>
    <span class="dot r37d26 water"></span>
    <span class="dot r37d27 water"></span>
    <span class="dot r37d28 water"></span>
    <span class="dot r37d29 water"></span>
    <span class="dot r37d30 water"></span>
    <span class="dot r37d31 water"></span>
    <span class="dot r37d32 water"></span>
    <span class="dot r37d33 water"></span>
    <span class="dot r37d34 water"></span>
    <span class="dot r37d35 water"></span>
    <span class="dot r37d36 water"></span>
    <span class="dot r37d37 water"></span>
    <span class="dot r37d38 water"></span>
    <span class="dot r37d39 water"></span>
    <span class="dot r37d40 water"></span>
    <span class="dot r37d41 water"></span>
    <span class="dot r37d42 water"></span>
    <span class="dot r37d43 water"></span>
    <span class="dot r37d44 water"></span>
    <span class="dot r37d45 water"></span>
    <span class="dot r37d46 water"></span>
    <span class="dot r37d47 water"></span>
    <span class="dot r37d48 water"></span>
    <span class="dot r37d49 water"></span>
    <span class="dot r37d50 water"></span>
    <span class="dot r37d51 water"></span>
    <span class="dot r37d52 water"></span>
    <span class="dot r37d53 water"></span>
    <span class="dot r37d54 water"></span>
    <span class="dot r37d55 water"></span>
    <span class="dot r37d56 water"></span>
    <span class="dot r37d57 water"></span>
    <span class="dot r37d58 water"></span>
    <span class="dot r37d59 water"></span>
    <span class="dot r37d60 water"></span>
    <span class="dot r37d61 water"></span>
    <span class="dot r37d62 water"></span>
    <span class="dot r37d63 water"></span>
    <span class="dot r37d64 water"></span>
    <span class="dot r37d65 water"></span>
    <span class="dot r37d66 water"></span>
    <span class="dot r37d67 water"></span>
    <span class="dot r37d68 water"></span>
  </div>
  <div class="row r38">
    <span class="dot r38d1 water"></span>
    <span class="dot r38d2 water"></span>
    <span class="dot r38d3 water"></span>
    <span class="dot r38d4 water"></span>
    <span class="dot r38d5 water"></span>
    <span class="dot r38d6 water"></span>
    <span class="dot r38d7 water"></span>
    <span class="dot r38d8 water"></span>
    <span class="dot r38d9 water"></span>
    <span class="dot r38d10 water"></span>
    <span class="dot r38d11 water"></span>
    <span class="dot r38d12 water"></span>
    <span class="dot r38d13 water"></span>
    <span class="dot r38d14 water"></span>
    <span class="dot r38d15 water"></span>
    <span class="dot r38d16 water"></span>
    <span class="dot r38d17 water"></span>
    <span class="dot r38d18 water"></span>
    <span class="dot r38d19 water"></span>
    <span class="dot r38d20 south-america"></span>
    <span class="dot r38d21 water"></span>
    <span class="dot r38d22 water"></span>
    <span class="dot r38d23 water"></span>
    <span class="dot r38d24 water"></span>
    <span class="dot r38d25 water"></span>
    <span class="dot r38d26 water"></span>
    <span class="dot r38d27 water"></span>
    <span class="dot r38d28 water"></span>
    <span class="dot r38d29 water"></span>
    <span class="dot r38d30 water"></span>
    <span class="dot r38d31 water"></span>
    <span class="dot r38d32 water"></span>
    <span class="dot r38d33 water"></span>
    <span class="dot r38d34 water"></span>
    <span class="dot r38d35 water"></span>
    <span class="dot r38d36 water"></span>
    <span class="dot r38d37 water"></span>
    <span class="dot r38d38 water"></span>
    <span class="dot r38d39 water"></span>
    <span class="dot r38d40 water"></span>
    <span class="dot r38d41 water"></span>
    <span class="dot r38d42 water"></span>
    <span class="dot r38d43 water"></span>
    <span class="dot r38d44 water"></span>
    <span class="dot r38d45 water"></span>
    <span class="dot r38d46 water"></span>
    <span class="dot r38d47 water"></span>
    <span class="dot r38d48 water"></span>
    <span class="dot r38d49 water"></span>
    <span class="dot r38d50 water"></span>
    <span class="dot r38d51 water"></span>
    <span class="dot r38d52 water"></span>
    <span class="dot r38d53 water"></span>
    <span class="dot r38d54 water"></span>
    <span class="dot r38d55 water"></span>
    <span class="dot r38d56 water"></span>
    <span class="dot r38d57 water"></span>
    <span class="dot r38d58 water"></span>
    <span class="dot r38d59 water"></span>
    <span class="dot r38d60 water"></span>
    <span class="dot r38d61 water"></span>
    <span class="dot r38d62 water"></span>
    <span class="dot r38d63 water"></span>
    <span class="dot r38d64 water"></span>
    <span class="dot r38d65 water"></span>
    <span class="dot r38d66 water"></span>
    <span class="dot r38d67 water"></span>
    <span class="dot r38d68 water"></span>
  </div>
</div>
